// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:04:38.763Z
// Property: The Ridge (ID: 6767906449166356)
// Collections: 35 amenities, 17 floorplans (live), 37 photos, 84 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166356",
  "property_external_id": "30950",
  "property_zillow_url": "https://www.zillow.com/apartments/hagerstown-md/the-ridge/5XtPdX/",
  "property_apartments_url": "https://www.apartments.com/the-ridge-hagerstown-md/e45t2xq/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Ridge+Apartment+Homes/data=!4m2!3m1!1s0x0:0xc282b0416fb39646?sa=X&ved=2ahUKEwiSt6WIhbmSAxXemWoFHZ5BHqgQ_BJ6BAhQEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "14928381749",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-ridge",
  "property_name": "The Ridge",
  "property_website_url": "https://www.theridgehagerstown.com/",
  "property_domain": "https://www.theridgehagerstown.com/",
  "property_address": "17920 Garden Lane",
  "property_full_address": "17920 Garden Ln, Hagerstown, MD 21740",
  "property_address_1": "17920 Garden Ln",
  "property_address_2": null,
  "property_address_city": "Hagerstown",
  "property_address_state": "MD",
  "property_address_zip_full": "21740-7936",
  "property_address_zip": "21740",
  "property_address_country": "US",
  "property_address_county": "Washington County",
  "property_neighborhood_address": "Outer Downtown/Maugansville",
  "property_address_latitude": "39.6127269",
  "property_address_longitude": "-77.74699629999999",
  "property_email": "theridge.pm@aionmanagement.com",
  "property_phone": "(301) 791-5300",
  "property_call_tracking_phone": "844-791-2477",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Nestled in Hagerstown, MD, The Ridge Apartments offers stylish one, two, and three-bedroom layouts designed for modern living. Enjoy resort-style amenities like a refreshing pool, state-of-the-art fitness center, and scenic walking trails. With a pet-friendly atmosphere and on-site management, your ideal home awaits. Secure your spot today!",
  "property_long_description": "Welcome to The Ridge Apartments, your ideal community in Hagerstown, MD! Offering a diverse range of floor plans, including one, two, and three-bedroom apartments, we cater to every lifestyle and need. Our spacious layouts feature modern amenities such as hardwood floors, walk-in closets, and fully-equipped kitchens with dishwashers and microwaves, ensuring comfort and convenience in every corner of your new home. \n\nAt The Ridge, we believe in providing more than just a place to live. Enjoy our resort-style amenities designed for relaxation and recreation. Take a refreshing dip in the pool, stay active in our state-of-the-art fitness center, or unwind at the sundeck and picnic area. Families will appreciate the playground, while pet owners can explore our dedicated dog park and pet play areas.\n\nOur community also boasts essential conveniences like on-site maintenance, laundry facilities, and a business center with online services to support your work-from-home needs. Whether you prefer a peaceful walk on nearby biking trails or a game of basketball, outdoor enthusiasts will find plenty to enjoy just steps from their front door.\n\nRelax in a smoke-free environment with features like air conditioning, ceiling fans, and cable-ready units. Choose from various delightful selections, whether you're looking for a cozy den or a spacious balcony to enjoy the views.\n\nFind your new home today at The Ridge Apartments! Browse our availability or schedule a tour to experience our vibrant community firsthand. Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-0c81-754e-83e0-764af33411a0.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of apartment buildings and amenities including a pool and playground.",
    "public_id": "019fce11-0c81-754e-83e0-764af33411a0",
    "storage_key": "property/6767906449166356/019fce11-0c81-754e-83e0-764af33411a0.webp",
    "width": 1920,
    "height": 1440
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "465",
  "property_year_built": "1963",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.9247311827957",
  "property_admin_fee": null,
  "property_application_fee": "25",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum 2 pets per apartment, each up to 100 lb.",
  "property_pet_policy_description": "Cats and dogs are welcome. Maximum 2 pets per apartment, each up to 100 lb. One-time pet fee: $700 per pet. Monthly pet rent: $75 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://theridgehagerstown.loftliving.com/login",
  "property_apply_now_url": "https://www.theridgehagerstown.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026c-a584-76d1-8783-a50cb29f24bd.webp",
  "property_primary_logo_media": {
    "alt_text": "The Ridge Apartment Homes logo",
    "public_id": "019d026c-a584-76d1-8783-a50cb29f24bd",
    "storage_key": "property/6767906449166356/019d026c-a584-76d1-8783-a50cb29f24bd.webp",
    "width": 340,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026f-8908-77d5-a6d4-c0e79856b880.webp",
  "property_secondary_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d026f-8908-77d5-a6d4-c0e79856b880",
    "storage_key": "property/6767906449166356/019d026f-8908-77d5-a6d4-c0e79856b880.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026f-982a-74be-9792-a5d98efafadd.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Ridge Apartment Homes logo",
    "public_id": "019d026f-982a-74be-9792-a5d98efafadd",
    "storage_key": "property/6767906449166356/019d026f-982a-74be-9792-a5d98efafadd.webp",
    "width": 340,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026f-a3c9-70c4-9939-61f711f34fe3.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Ridge Apartment Homes logo",
    "public_id": "019d026f-a3c9-70c4-9939-61f711f34fe3",
    "storage_key": "property/6767906449166356/019d026f-a3c9-70c4-9939-61f711f34fe3.webp",
    "width": 340,
    "height": 160
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "600 - 1300",
  "property_sqft_min": "600",
  "property_sqft_max": "1300",
  "property_price_range": "1974",
  "property_price_min": null,
  "property_price_max": "1974",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/theridgehagerstown/",
  "property_instagram_url": "https://www.instagram.com/theridgehagerstown",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJT73Tz3jyyYkRRpazb0GwgsI",
  "property_youtube_url": "https://www.youtube.com/watch?v=EVKHJiRnZMU",
  "property_yelp_url": "https://www.yelp.com/biz/oak-ridge-apartments-hagerstown-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Ridge Apartments",
  "property_home_romance_title": "Embrace the Joy of Living in Your Perfect Home",
  "property_home_amenities_blurb": "Welcome to The Ridge Apartments in Hagerstown, MD, where comfort meets convenience. Choose from our stylish one, two, or three-bedroom floor plans, perfectly complemented by luxurious amenities like a refreshing pool, a vibrant playground, and serene walking trails. Your ideal home awaits—embrace a lifestyle elevated with us!",
  "property_home_floorplans_blurb": "At The Ridge Apartments in Hagerstown, MD, stylish living awaits you. Choose from our thoughtfully designed one, two, or three-bedroom floor plans tailored for comfort and convenience. Your ideal home is just a click away—browse our available apartments and find the perfect fit for your lifestyle today!",
  "property_home_gallery_blurb": "At The Ridge Apartments in Hagerstown, MD, your ideal home awaits! Choose from a variety of spacious floor plans, each thoughtfully designed with amenities like a sparkling pool, a fitness center, and a welcoming dog park. Picture yourself living here—where comfort meets convenience and community thrives!",
  "property_home_neighborhood_blurb": "At The Ridge Apartments in Hagerstown, MD, enjoy a vibrant community with diverse floor plans, from cozy one-bedroom to spacious three-bedroom apartments. Embrace convenient access to local treasures like the Washington County Museum of Fine Arts, Hagerstown Community College, and scenic parks. Dive into your new lifestyle today!",
  "property_home_reviews_blurb": "At The Ridge Apartments in Hagerstown, MD, our residents rave about the exceptional living experience. Enjoy quiet, well-maintained surroundings, responsive maintenance, and fantastic amenities like two sparkling pools and a fitness center. As one resident noted, \"This is one of the best apartment complexes in the area.\" Join our vibrant community today!",
  "property_neighborhood_blurb": "At The Ridge Apartments in Hagerstown, MD, vibrant living meets convenience. Nestled near local treasures like the Washington County Museum of Fine Arts and the serene trails of C&O Canal National Historical Park, our community is perfectly situated for those seeking a blend of culture and recreation. See what's around our neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Ridge Apartments in Hagerstown, MD, a vibrant lifestyle awaits! Enjoy thoughtfully designed one, two, and three-bedroom floor plans alongside premium amenities. Relax by the pool, challenge friends on the basketball court, or unwind in the dog park. Experience the perfect blend of comfort and convenience today!",
  "property_applynow_blurb": "At The Ridge Apartments in Hagerstown, MD, choose from spacious one, two, or three-bedroom floor plans designed for your lifestyle. Delight in a range of amenities, from a refreshing pool and modern fitness center to serene walking trails and a vibrant dog park. Lease online today and elevate your living experience!",
  "property_contactus_blurb": "At The Ridge Apartments in Hagerstown, MD, we offer spacious one, two, and three-bedroom floor plans designed for your lifestyle. Each layout combines comfort and style, perfect for making lifelong memories. Have questions? Reach out to our leasing team today and find your ideal home!",
  "property_faqs_blurb": "At The Ridge Apartments in Hagerstown, MD, we offer a range of floor plans, including cozy one-bedroom, spacious two-bedroom, and expansive three-bedroom options. Curious about our community? Our FAQs page is your go-to resource for answers to all your burning questions—come see what makes us unique!",
  "property_floorplans_blurb": "At The Ridge Apartments in Hagerstown, MD, you'll find thoughtfully designed floor plans to suit your lifestyle. Choose from charming one-bedroom retreats to spacious three-bedroom havens. Each home offers unique features to elevate your living experience. Browse our available apartment options and find your perfect sanctuary today!",
  "property_gallery_blurb": "Picture life at The Ridge Apartments in Hagerstown, MD—where comfort meets community. Enjoy stunning one to three-bedroom floor plans alongside unbeatable amenities. Dive into the refreshing pool, maintain your active lifestyle in the fitness center, or unwind in the serene picnic area. Your perfect home awaits!",
  "property_interactivemap_blurb": "At The Ridge Apartments in Hagerstown, MD, choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Enjoy abundant amenities like a sparkling pool, fitness center, dog park, and walking trails. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "Welcome to The Ridge Apartments in Hagerstown, MD, where comfort meets convenience. Enjoy spacious living with your furry friends, as we proudly accommodate up to two pets per apartment! Relish in the community's vibrant lifestyle while creating lasting memories in your cozy, pet-friendly retreat amidst stunning natural views.",
  "property_referafriend_blurb": "At The Ridge Apartments in Hagerstown, MD, your ideal home awaits—whether it's a cozy one-bedroom or a spacious three-bedroom layout. Enrich your living experience by sharing the joy with friends; great friends make great neighbors! Refer a friend today and discover the vibrant community that awaits you.",
  "property_residentaccess_blurb": "Welcome to The Ridge Apartments in Hagerstown, MD, where comfort meets convenience. Our diverse floor plans range from one to three bedrooms, tailored to fit your lifestyle. Access your resident portal to effortlessly pay rent, schedule maintenance, and embrace a seamless living experience today!",
  "property_reviews_blurb": "At The Ridge Apartments in Hagerstown, MD, residents rave about the exceptional service and community spirit. One resident says, \"Maintenance has always been very good about arriving in a timely manner,\" highlighting our commitment to quality living. Join us and experience a comfortable, inviting space you'll love calling home!",
  "property_created_at": "1757012526441",
  "property_scheduletour_blurb": "At The Ridge Apartments in Hagerstown, MD, choose from our thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Experience modern living with community vibes. Schedule a tour today and find out why residents love calling The Ridge home! Check out their testimonials!",
  "property_thankyou_blurb": "Thank you for reaching out to The Ridge Apartments in Hagerstown, MD! Our diverse floor plans, from cozy one-bedroom hideaways to spacious three-bedroom homes, are tailored to fit your lifestyle. A member of our friendly team will connect with you shortly to help you find your perfect space!",
  "property_virtualtours_blurb": "Experience The Ridge Apartments in Hagerstown, MD, where stylish floor plans meet modern living. Choose from one, two, or three-bedroom options tailored for your lifestyle. Ready to see your future home? Take a virtual tour and immerse yourself in our vibrant community today!",
  "property_copyright": "2025 All Rights Reserved. The Ridge Apartments",
  "property_seo_title_home": "The Ridge Apartments |  Apartments in Hagerstown, MD",
  "property_seo_description_home": "Live at The Ridge Apartments in Hagerstown! Enjoy modern amenities, from pools to playgrounds. Choose from spacious one, two, or three-bedroom layouts!",
  "property_seo_title_floorplans": "Floor Plans | Hagerstown, MD Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at The Ridge Apartments in Hagerstown, MD. Choose from stylish one, two, or three-bedroom floor plans. Your new home awaits!",
  "property_seo_title_amenities": "Amenities | Hagerstown, MD Apartments for Rent",
  "property_seo_description_amenities": "Enjoy comfort at The Ridge Apartments in Hagerstown, MD, featuring pools, fitness centers, dog parks, and more tailored for your lifestyle!",
  "property_seo_title_gallery": "Gallery | Apartments in Hagerstown, MD",
  "property_seo_description_gallery": "Elevate your lifestyle at The Ridge Apartments in Hagerstown, MD. Picture your perfect home with stunning amenities and breathtaking views!",
  "property_seo_title_virtualtours": "Virtual Tours | The Ridge Apartments Apartments",
  "property_seo_description_virtualtours": "Step into The Ridge Apartments in Hagerstown, MD. Enjoy one to three-bedroom options and take a virtual tour of your future home today!",
  "property_seo_title_interactivemap": "Interactive Map | The Ridge Apartments Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at The Ridge Apartments in Hagerstown, MD. Use our interactive map to explore spacious floor plans and amenities tailored for comfort!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Hagerstown, MD",
  "property_seo_description_neighborhood": "Experience Hagerstown living at The Ridge Apartments! Uncover local gems and vibrant hotspots just steps from your door. Your new adventure awaits!",
  "property_seo_title_contact": "Contact Us | The Ridge Apartments",
  "property_seo_description_contact": "Find your perfect home at The Ridge Apartments in Hagerstown, MD. Inquire about our spacious one, two, and three-bedroom floor plans. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Hagerstown, MD",
  "property_seo_description_faqs": "Find answers to your questions about life at The Ridge Apartments in Hagerstown, MD. From floor plans to amenities, your perfect home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Hagerstown, MD",
  "property_seo_description_reviews": "Experience life at The Ridge Apartments in Hagerstown, MD. See why residents love our spacious layouts, top-notch amenities, and vibrant community lifestyle!",
  "property_seo_title_applynow": "Apply Now | Apartments in Hagerstown, MD",
  "property_seo_description_applynow": "Discover comfort at The Ridge Apartments in Hagerstown, MD. Enjoy spacious layouts and excellent amenities—lease online today!",
  "property_seo_title_residentaccess": "Resident Access | The Ridge Apartments",
  "property_seo_description_residentaccess": "Log in to The Ridge Apartments' resident portal in Hagerstown, MD—your go-to for rent payments, maintenance requests, and community updates, all in one place!",
  "property_seo_title_referafriend": "Refer A Friend | The Ridge Apartments",
  "property_seo_description_referafriend": "Refer a friend to The Ridge Apartments in Hagerstown, MD, and enjoy the perks of great neighbors! Share the joy of community living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Ridge Apartments",
  "property_seo_description_scheduletour": "Experience the charm of The Ridge Apartments in Hagerstown, MD. Schedule a tour today and step into your future home surrounded by comfort and style!",
  "property_seo_title_privacy": "Privacy Policy | The Ridge Apartments",
  "property_seo_description_privacy": "Learn how The Ridge Apartments in Hagerstown, MD safeguards your information. Your privacy matters—view our policy for peace of mind.",
  "property_seo_title_accessibility": "Website Accessibility | The Ridge Apartments",
  "property_seo_description_accessibility": "Experience seamless living at The Ridge Apartments in Hagerstown, MD. We prioritize digital inclusion for everyone—everyone deserves a home that connects!",
  "property_seo_title_sitemap": "Sitemap | The Ridge Apartments",
  "property_seo_description_sitemap": "Navigate The Ridge Apartments in Hagerstown, MD, with ease. Access our sitemap to find your new home and uncover all we have to offer!",
  "property_seo_title_thankyou": "Thank You | The Ridge Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! A member of The Ridge Apartments team in Hagerstown, MD, will connect with you soon. Your new home awaits!",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1791293568386",
  "amenities": [
    {
      "id": "custom_dd522343-3b66-4870-91fd-c3fe811bcea4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b5503db5-229d-45bc-9e38-f16f48f77f68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8382f291-b3c3-49f2-8f59-d03050f2f77b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f40ec5d-5e65-45ca-b185-e6cd2fc45d6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Centers in Each Building",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0d3e4d04-1b11-4ed2-b39f-537c7e63a5ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_732afbd7-786a-4dc3-8554-c56b6bc5fd42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7311c7c8-fd92-43b4-9f31-64e8765768dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d1441fda-25d5-48ff-9ae7-621de8901f11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8c83f0c1-b7b7-43f2-b256-09c42735ac7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8d75b817-c649-4287-9e8d-344eaf63f7bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leases Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3987530a-cd49-45a2-9e48-586dccfeacb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Space Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9c1cb222-c070-405b-b61c-2a9d3c1608e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Built-in Microwave*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c41629d0-4276-489f-9456-a54c06c99a82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fd50155e-882d-4bdb-a79b-53f057135359",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a00b68cd-6c5b-44f4-a684-1ff925032d7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b5667bc3-2fd3-4859-a416-a1d7c880454a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Dens*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d0492a60-0602-435e-b641-6bdde6bbd2e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_246d9b5a-51e2-43c5-9257-e573e2421cd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplaces*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_275bbdae-e12b-4ae5-ab7a-c5ea76014270",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet Available",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0459e461-9166-4335-8070-ef7c0c0582b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2540454f-d7df-403b-8737-3b2f14a44bdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated 1, 2 & 3 Bedroom Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6809b3c8-a27d-4479-ac91-439999888383",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_922b5b2b-ef1b-4f08-8f5d-d46beb81ae20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Wall-to-Wall Carpet",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c4eb7ff0-3ded-4b29-b8c3-2b11979f3a99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to I-70, I-81, and Route 40.",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a8ab55b4-bc4f-408a-a787-58f9ae34bc00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Minutes to Valley Mall & Hagerstown Premium Outlets",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ba119164-87ad-4891-9640-83d57644643d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Walk to Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_30a9b334-8251-4f60-b3e4-2aaf575eb2ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "3 Miles to the Arts and Entertainment District",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_86d8eb61-3082-49c8-ad18-ef8f59502ef7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cae4efb5-b2a5-4445-b0cd-82800ec6cc10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Beautifully Landscaped Grounds",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa09a574-5455-4d7f-be01-dfcfe312dcaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a1942590-a4e2-4989-a032-f8373111bf54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling & Picnic Pavilion",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8953c276-2a30-4d0b-83f5-8a7d48f87e56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Pavilion and Firepit *Coming Soon",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ef31a150-4f9e-4d01-8335-af3b3159abfa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e893540-0a99-4d35-a5f0-33851faaa12c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_03f4219d-cfaa-41e7-a2b7-6e33b387fe66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool with Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0d185890-7b72-415c-875e-ae744ecad8d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-1d1d-745f-92db-4b133c077223.webp",
      "image_media": {
        "alt_text": "Kitchen with dark cabinets, stainless steel sink, black refrigerator, and a window.",
        "public_id": "019fce11-1d1d-745f-92db-4b133c077223",
        "storage_key": "property/6767906449166356/019fce11-1d1d-745f-92db-4b133c077223.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Modern, compact galley kitchen in a stylish apartment with dark cabinetry and black appliances.",
      "link": "false",
      "alt_text": "Narrow galley kitchen with dark cabinets, granite-like counters, black appliances, and a window at the far end at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/9412a5a629cdfb5012a5238c7b0bd60e.webp"
    },
    {
      "id": "custom_da4876a9-bf6c-420a-b581-893431f41582",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-1d6b-730b-a988-e3943caeb241.webp",
      "image_media": {
        "alt_text": "Bright living room with a sofa, coffee table, and TV.",
        "public_id": "019fce11-1d6b-730b-a988-e3943caeb241",
        "storage_key": "property/6767906449166356/019fce11-1d6b-730b-a988-e3943caeb241.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright living room in a modern apartment with neutral tones, a sofa, coffee table, TV, and a sliding door to the outdoors.",
      "link": "false",
      "alt_text": "Living room with beige sofa, round coffee table, TV on a white console, and a sliding glass door at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/008cd003f4276e888fa6718499918dd1.jpg"
    },
    {
      "id": "custom_66d1f494-baa9-4d8d-9935-7f29ad1b6f4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-1d6b-730b-a988-df50054e09a1.webp",
      "image_media": {
        "alt_text": "Dining room with a dark wood table and upholstered chairs, leading to a kitchen.",
        "public_id": "019fce11-1d6b-730b-a988-df50054e09a1",
        "storage_key": "property/6767906449166356/019fce11-1d6b-730b-a988-df50054e09a1.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright dining area in a modern apartment with a dark rustic table, cream chairs, and wall art.",
      "link": "false",
      "alt_text": "Dining area in a modern apartment with a dark wood table and cream upholstered chairs; kitchen doorway visible at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/523094c811dea9631901a2a1f8aa8462.jpg"
    },
    {
      "id": "custom_9922f179-9f78-4506-ac8b-295ed4608e39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-1d80-74cb-ac3e-2a0aaa5143db.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, dresser, and wall-mounted TV.",
        "public_id": "019fce11-1d80-74cb-ac3e-2a0aaa5143db",
        "storage_key": "property/6767906449166356/019fce11-1d80-74cb-ac3e-2a0aaa5143db.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment bedroom with neutral tones, a dresser, and wall-mounted TV.",
      "link": "false",
      "alt_text": "Bedroom in an apartment with a low-profile bed, gray headboard, and dresser by a window at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/221ad903efe4430e54da6fa43256ea74.jpg"
    },
    {
      "id": "custom_1f67afff-6b94-4eb3-b0a6-44abd7ccfe2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-2845-76be-8bef-94259fbad8da.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel sink, and black appliances.",
        "public_id": "019fce11-2845-76be-8bef-94259fbad8da",
        "storage_key": "property/6767906449166356/019fce11-2845-76be-8bef-94259fbad8da.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring white cabinetry, granite countertops, and modern black appliances, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Narrow galley kitchen with white cabinets, stainless sink, black appliances, and a window at the far end at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/101573e6f93df99498a74ddd674ef26f.webp"
    },
    {
      "id": "custom_f3e69584-ee28-49b1-97c9-21b57d7ca611",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-2844-72dd-9b58-f76d47fcc0d6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets and granite countertops, featuring a black refrigerator and stainless steel sink.",
        "public_id": "019fce11-2844-72dd-9b58-f76d47fcc0d6",
        "storage_key": "property/6767906449166356/019fce11-2844-72dd-9b58-f76d47fcc0d6.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with white cabinets, stainless fridge and stove, and a double sink.",
      "link": "false",
      "alt_text": "Modern galley kitchen with white cabinets, gray countertops, and stainless appliances at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/ac4b6b1c7caed4a03c7eeb91f930f4b1.webp"
    },
    {
      "id": "custom_ae227a41-c797-4380-895e-bd03c081a2be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-2a31-7578-a6dc-c6937180c3e1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel sink.",
        "public_id": "019fce11-2a31-7578-a6dc-c6937180c3e1",
        "storage_key": "property/6767906449166356/019fce11-2a31-7578-a6dc-c6937180c3e1.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with clean white cabinetry, laminate countertop, and a sunny window.",
      "link": "false",
      "alt_text": "White kitchen with white cabinets, beige countertop, stainless steel sink, and a window with blinds at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/fb54ec28e59cfb7462620885430e874d.jpg"
    },
    {
      "id": "custom_360d0282-85ed-412c-b6c5-3af41bd68670",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-2acf-75da-9bd8-b734c9feb518.webp",
      "image_media": {
        "alt_text": "Living and dining room with a TV, couch, and dining table, with large sliding glass doors leading to the outdoors.",
        "public_id": "019fce11-2acf-75da-9bd8-b734c9feb518",
        "storage_key": "property/6767906449166356/019fce11-2acf-75da-9bd8-b734c9feb518.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a large TV, comfortable seating, and a dining table. Sliding glass doors open to lush outdoor views, creating a bright and inviting atmosphere.",
      "link": "false",
      "alt_text": "Living room in an apartment with a sofa, coffee table, TV, and a dining area near sliding doors at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/20dc3a38f29316592fb555d32e2dc66b.jpg"
    },
    {
      "id": "custom_473b539e-56ed-4bd2-8d65-1c0544827b43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-3360-722c-8201-a84275336270.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sofa, coffee table, and entertainment center.",
        "public_id": "019fce11-3360-722c-8201-a84275336270",
        "storage_key": "property/6767906449166356/019fce11-3360-722c-8201-a84275336270.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Bright, modern apartment living room with neutral furnishings and access to the outdoors through sliding doors.",
      "link": "false",
      "alt_text": "Living room in an apartment with a sofa, coffee table, wall-mounted TV, and sliding glass doors with vertical blinds at The Ridge Apartments in Hagerstown, MD.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/9913e7ed1425d4e7f32c27351504eb69.jpg"
    },
    {
      "id": "custom_ba78ca23-3c08-4916-8eb6-c86d8028311b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-3352-7768-91ad-b9c6b3197d69.webp",
      "image_media": {
        "alt_text": "Dining room with a table set for four, adjacent to a kitchen.",
        "public_id": "019fce11-3352-7768-91ad-b9c6b3197d69",
        "storage_key": "property/6767906449166356/019fce11-3352-7768-91ad-b9c6b3197d69.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Interior dining area in a multifamily unit with wall art, a ceiling fan, and an open kitchen.",
      "link": "false",
      "alt_text": "Dining area in an apartment with a wooden table, cream chairs, wall art, and a view into the adjacent kitchen at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/b473472c70274730011aa60d9cd58c47.jpg"
    },
    {
      "id": "custom_cda5e4b6-cbba-47b5-821b-bb732439389f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-35e5-767d-92a9-c4b46de6a3ea.webp",
      "image_media": {
        "alt_text": "Living area with a dining table and a home office setup.",
        "public_id": "019fce11-35e5-767d-92a9-c4b46de6a3ea",
        "storage_key": "property/6767906449166356/019fce11-35e5-767d-92a9-c4b46de6a3ea.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious apartment living area featuring a study desk, dining space, and cozy seating.",
      "link": "false",
      "alt_text": "Interior living area with a desk, computer, dining nook, and neutral decor at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/ef0c38c7a04bcb0f759b1c3b05d0017a.jpg"
    },
    {
      "id": "custom_a6c9ef0c-54d0-438a-8262-f0192534f10e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-3701-74fd-8edd-bb404ba46d04.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, coffee table, and TV.",
        "public_id": "019fce11-3701-74fd-8edd-bb404ba46d04",
        "storage_key": "property/6767906449166356/019fce11-3701-74fd-8edd-bb404ba46d04.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright, modern apartment living space with neutral decor, balcony access, and an entertainment area.",
      "link": "false",
      "alt_text": "Living room in an apartment with a white sofa, coffee table, TV, sliding glass door, and tall potted plants at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/5df14290abb1f10e9f990d76956d2e5b.jpg"
    },
    {
      "id": "custom_d0a6c8ec-c42f-443a-ac61-621b8998909a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-3de9-723b-ad56-bee6ce73bd36.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs, and a view into the kitchen.",
        "public_id": "019fce11-3de9-723b-ad56-bee6ce73bd36",
        "storage_key": "property/6767906449166356/019fce11-3de9-723b-ad56-bee6ce73bd36.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Elegant dining area with a table and chairs, perfect for meals and gatherings. Includes a view of the adjacent kitchen.",
      "link": "false",
      "alt_text": "Dining area in an apartment: wooden table, four gray upholstered chairs, ceiling fan, and wall shelves at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/d0f45487213b9a36921a60c9a261003b.jpg"
    },
    {
      "id": "custom_6556e5b1-d501-4181-812c-4eee9ba6bb9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-40b6-71a0-8a8e-411fc68e29bb.webp",
      "image_media": {
        "alt_text": "A home office with a desk, chair, and a bookshelf.",
        "public_id": "019fce11-40b6-71a0-8a8e-411fc68e29bb",
        "storage_key": "property/6767906449166356/019fce11-40b6-71a0-8a8e-411fc68e29bb.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright apartment interior featuring a compact home office with a white desk, gray chair, built-in shelves, and a window overlooking greenery.",
      "link": "false",
      "alt_text": "Home office in an apartment: white desk, gray chair, floor lamp, tall white bookcase, and a window with blinds at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/dda16582b302a16e4cb35eb19c694fc3.jpg"
    },
    {
      "id": "custom_a7b9a6f1-863d-4e1b-9d13-b3dd7428dd32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-4126-7304-ba4e-75839c93994b.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet and a dresser with decorative items.",
        "public_id": "019fce11-4126-7304-ba4e-75839c93994b",
        "storage_key": "property/6767906449166356/019fce11-4126-7304-ba4e-75839c93994b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Neutral-toned bedroom in a multifamily unit featuring two dressers, decorative mirrors, and an open closet.",
      "link": "false",
      "alt_text": "Neutral-toned bedroom with a bed, two dressers, and an open closet at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/9324ecf0d57fada0857645031e9bf360.jpg"
    },
    {
      "id": "custom_9f94c22c-212a-49ed-b77d-3cf7c73f9d8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-4304-71aa-9089-90b91d09392e.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, a TV, and a window overlooking trees.",
        "public_id": "019fce11-4304-71aa-9089-90b91d09392e",
        "storage_key": "property/6767906449166356/019fce11-4304-71aa-9089-90b91d09392e.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our spacious bedrooms. Featuring plush carpeting, modern entertainment centers, and serene views.",
      "link": "false",
      "alt_text": "Modern apartment bedroom with a bed, dresser, wall-mounted TV, and large potted plant at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/b4dd4bb59d8c159f505742f2ab37c888.webp"
    },
    {
      "id": "custom_4cc68300-3111-48eb-9a5a-447c9d9786f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-4a38-71dd-83cc-55f9ead0a998.webp",
      "image_media": {
        "alt_text": "Bedroom with a TV and a bed",
        "public_id": "019fce11-4a38-71dd-83cc-55f9ead0a998",
        "storage_key": "property/6767906449166356/019fce11-4a38-71dd-83cc-55f9ead0a998.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with a large bed, light wood dresser, wall TV, and doors to the bath and closet.",
      "link": "false",
      "alt_text": "Bedroom in an apartment with a large bed, dresser, wall-mounted TV, and doors to the bathroom and closet at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/7734cdf5ce8d971cc1c6aaf3dfb3a9d4.jpg"
    },
    {
      "id": "custom_998ff447-6228-470a-ad61-fab9e5976cfe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-4bec-7256-a230-f4f76680f743.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet and a bed",
        "public_id": "019fce11-4bec-7256-a230-f4f76680f743",
        "storage_key": "property/6767906449166356/019fce11-4bec-7256-a230-f4f76680f743.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment bedroom with an open closet, light gray bedding, and minimal decor.",
      "link": "false",
      "alt_text": "Bedroom with a neatly made bed, open closet, and neutral-toned walls at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/ab99c9b9df5d02f729593500a3ea2e38.jpg"
    },
    {
      "id": "custom_e458e7f5-cb6a-454e-abe9-0a03896fd31e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-4c49-742e-ba85-8a69e3cb7169.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, black faucet, mirrored medicine cabinet, and a bathtub with a black shower curtain.",
        "public_id": "019fce11-4c49-742e-ba85-8a69e3cb7169",
        "storage_key": "property/6767906449166356/019fce11-4c49-742e-ba85-8a69e3cb7169.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Bright, modern apartment bathroom featuring a white vanity, mirror cabinet, and a shower/tub combo.",
      "link": "false",
      "alt_text": "White bathroom with a tub/shower, toilet, and a white vanity at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/e49a0edcf97912f2a16dfb055d84b9c5.jpg"
    },
    {
      "id": "custom_3fc83c68-9e84-4465-b873-814bdd22becd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-501d-718e-94d6-35e48457223d.webp",
      "image_media": {
        "alt_text": "Bathroom with white tub and toilet, and hallway leading to bedrooms.",
        "public_id": "019fce11-501d-718e-94d6-35e48457223d",
        "storage_key": "property/6767906449166356/019fce11-501d-718e-94d6-35e48457223d.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Bright bathroom in a modern apartment unit featuring a bathtub/shower, vanity, and neutral gray walls.",
      "link": "false",
      "alt_text": "Bathroom in an apartment unit with a tub/shower, toilet, and vanity at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/18bb1dda2dac18cca249e12a1b1625fa.jpg"
    },
    {
      "id": "custom_693b9abf-eee4-4bfe-8e47-4f808707338e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-5630-75ba-aca2-76ea50f1f0e1.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fce11-5630-75ba-aca2-76ea50f1f0e1",
        "storage_key": "property/6767906449166356/019fce11-5630-75ba-aca2-76ea50f1f0e1.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Outdoor pool area at our apartment community with seating and umbrellas for residents.",
      "link": "false",
      "alt_text": "Outdoor community pool area with lounge chairs, orange umbrellas, and greenery at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/a18ddba0f6549d1f6e1dc45201baf4f0.jpg"
    },
    {
      "id": "custom_253439b5-58e4-4c19-92dc-d7ff1f788c4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-5712-7228-8575-c1ed21adfe8c.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and tables.",
        "public_id": "019fce11-5712-7228-8575-c1ed21adfe8c",
        "storage_key": "property/6767906449166356/019fce11-5712-7228-8575-c1ed21adfe8c.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, perfect for relaxing or entertaining guests on a warm day. Ample lounge chairs and seating areas are available.",
      "link": "false",
      "alt_text": "Outdoor pool area with orange umbrellas and black lounge chairs on a concrete deck at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/113f7e453806e602065b40165703cd51.jpg"
    },
    {
      "id": "custom_754ad613-89ca-46a2-83e7-b0141538ced0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-59e4-7617-b63c-c431cf098edb.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a table and chairs under an orange umbrella.",
        "public_id": "019fce11-59e4-7617-b63c-c431cf098edb",
        "storage_key": "property/6767906449166356/019fce11-59e4-7617-b63c-c431cf098edb.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Spacious outdoor community pool area with seating and an orange umbrella for shade on a sunny day.",
      "link": "false",
      "alt_text": "Circular outdoor pool with a black fence, concrete deck, and a table with an orange umbrella at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/f843985fef55fb4ed0dca0e060cbf337.jpg"
    },
    {
      "id": "custom_29935e01-c271-4b21-918a-6d471246983a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-5ba4-736b-bdb6-dfa904c2e6b8.webp",
      "image_media": {
        "alt_text": "Covered picnic pavilion with grills and picnic tables, adjacent to a swimming pool.",
        "public_id": "019fce11-5ba4-736b-bdb6-dfa904c2e6b8",
        "storage_key": "property/6767906449166356/019fce11-5ba4-736b-bdb6-dfa904c2e6b8.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at our community picnic pavilion, complete with grills and ample seating. Relax by the sparkling swimming pool, perfect for sunny days.",
      "link": "false",
      "alt_text": "Wooden gazebo pavilion with picnic tables on a concrete pad in a grassy park near a pool at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/4139f853f2e0fc0c66c40a745cbc83c7.jpg"
    },
    {
      "id": "custom_a53ca14f-c820-416d-ac2e-a24d69314d8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-631e-737d-8d2b-0f302dee7ce6.webp",
      "image_media": {
        "alt_text": "Playground with swings and a slide in a grassy area.",
        "public_id": "019fce11-631e-737d-8d2b-0f302dee7ce6",
        "storage_key": "property/6767906449166356/019fce11-631e-737d-8d2b-0f302dee7ce6.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Outdoor community playground at the property featuring a colorful playset and slide in a grassy park area.",
      "link": "false",
      "alt_text": "Playground equipment on a sandy surface with grass and trees around at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/3eb060bea7be46599a203366f6f78c9a.jpg"
    },
    {
      "id": "custom_f1b88642-027c-438c-9a3f-5ac28c17557d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-6513-74dd-98df-b381ace4c85c.webp",
      "image_media": {
        "alt_text": "A colorful playground with slides and swings surrounded by green trees and a blue sky.",
        "public_id": "019fce11-6513-74dd-98df-b381ace4c85c",
        "storage_key": "property/6767906449166356/019fce11-6513-74dd-98df-b381ace4c85c.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Bright playground at the property’s community amenities, featuring a multi-colored play structure with slides and climbing elements.",
      "link": "false",
      "alt_text": "Colorful outdoor playground with slides, stairs and climbing bars on a wood-chip surface at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/43dedeb3c69debb2dccf595e7724aeeb.webp"
    },
    {
      "id": "custom_a631ba58-3ade-4361-bc69-6fe6fe0c353f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-65d6-77fe-ae36-50400aad0198.webp",
      "image_media": {
        "alt_text": "Two outdoor grills in a grassy area with trees in the background.",
        "public_id": "019fce11-65d6-77fe-ae36-50400aad0198",
        "storage_key": "property/6767906449166356/019fce11-65d6-77fe-ae36-50400aad0198.webp",
        "width": 1621,
        "height": 1082
      },
      "title": "Community",
      "description": "Outdoor communal grilling area with two gas grills on a green lawn; a wooded backdrop with a fence and signage.",
      "link": "false",
      "alt_text": "Two black outdoor grills on a grassy lawn with trees and fencing in the background at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/f70460e508a73a383b8dde530fa79e3b.jpg"
    },
    {
      "id": "custom_6903ca56-8f16-4853-9626-936cf51aeb0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-6836-755f-9369-0b8638ca1462.webp",
      "image_media": {
        "alt_text": "Outdoor picnic area with grills and covered seating.",
        "public_id": "019fce11-6836-755f-9369-0b8638ca1462",
        "storage_key": "property/6767906449166356/019fce11-6836-755f-9369-0b8638ca1462.webp",
        "width": 1621,
        "height": 1082
      },
      "title": "Community",
      "description": "Shared outdoor space with grills, a pavilion, and seating for residents to enjoy meals and gatherings.",
      "link": "false",
      "alt_text": "Outdoor community grill area with a wooden pavilion and picnic tables on a concrete pad at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/cedad2f71c16c930de87f0e1b689a380.jpg"
    },
    {
      "id": "custom_82a93022-1ccd-49b4-b16c-b2eab97c96c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-6ffb-7566-ba5a-d6f9c3584390.webp",
      "image_media": {
        "alt_text": "Playground and fenced-in area with benches and fire hydrant.",
        "public_id": "019fce11-6ffb-7566-ba5a-d6f9c3584390",
        "storage_key": "property/6767906449166356/019fce11-6ffb-7566-ba5a-d6f9c3584390.webp",
        "width": 1621,
        "height": 1082
      },
      "title": "Community",
      "description": "Outdoor playground and lawn at a multifamily property, with brick buildings in the background.",
      "link": "false",
      "alt_text": "Fenced playground with red metal arches in foreground and brick apartment buildings behind at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/37aa495cd4a68a4101196fa6bc78d742.jpg"
    },
    {
      "id": "custom_bede6736-fdea-4c46-947d-602dcdf154c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-725d-70b7-a405-84f877d6e6dd.webp",
      "image_media": {
        "alt_text": "Outdoor fitness park with pull-up bars and benches.",
        "public_id": "019fce11-725d-70b7-a405-84f877d6e6dd",
        "storage_key": "property/6767906449166356/019fce11-725d-70b7-a405-84f877d6e6dd.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Outdoor fitness park at the apartment community with metal workout stations, benches, and open green space.",
      "link": "false",
      "alt_text": "Outdoor community fitness park with green metal exercise stations on a grassy field at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/e4dfbc4a1c6db17097be8bc8c8e299b0.webp"
    },
    {
      "id": "custom_90a0c159-f80f-49ad-b623-861088c84ed1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-74b9-70da-97a2-9c8009e3af5c.webp",
      "image_media": {
        "alt_text": "Dog park area with chain link fence, welcome sign, and dog rules.",
        "public_id": "019fce11-74b9-70da-97a2-9c8009e3af5c",
        "storage_key": "property/6767906449166356/019fce11-74b9-70da-97a2-9c8009e3af5c.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Shows the property's community dog park with a yellow welcome sign and rules board in a grassy, fenced area.",
      "link": "false",
      "alt_text": "Dog park sign inside a fenced grassy area with trees at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/8299702df514ac2c4e2d148ecb08d279.jpg"
    },
    {
      "id": "custom_bcb9a0c1-391d-4518-aea7-bb18c69ad388",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-77cd-7612-9835-ac515f1dfd5f.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, free weights, and exercise balls.",
        "public_id": "019fce11-77cd-7612-9835-ac515f1dfd5f",
        "storage_key": "property/6767906449166356/019fce11-77cd-7612-9835-ac515f1dfd5f.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Well-equipped community gym featuring free weights, benches, and a cable machine for residents.",
      "link": "false",
      "alt_text": "Indoor fitness center with dumbbells, benches, and a cable machine near windows at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/6c8e2cd79d9e64fc0682f9641f2e68a2.webp"
    },
    {
      "id": "custom_8fe945f2-7011-4b72-9b3a-664e7b5fdb9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-7d24-731b-9aa6-675a3b402caf.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, and a stationary bike.",
        "public_id": "019fce11-7d24-731b-9aa6-675a3b402caf",
        "storage_key": "property/6767906449166356/019fce11-7d24-731b-9aa6-675a3b402caf.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring treadmills, ellipticals, and other cardio equipment for residents.",
      "link": "false",
      "alt_text": "Indoor fitness center with treadmills, ellipticals, and a wall-mounted TV by large windows at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/0fdc2d783c27ccd24b35fb625cfd5839.webp"
    },
    {
      "id": "custom_6a2bf9c6-4c56-47c8-bd85-a69d53d706e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-813e-748f-a5e2-2f4217ddb184.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019fce11-813e-748f-a5e2-2f4217ddb184",
        "storage_key": "property/6767906449166356/019fce11-813e-748f-a5e2-2f4217ddb184.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Modern apartment community gym with cardio equipment, free weights, and a mirrored wall.",
      "link": "false",
      "alt_text": "Bright community gym with cardio machines and free weights at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/640d4264a14797adf660074722b44911.webp"
    },
    {
      "id": "custom_a73e6eab-74a2-4cc9-a88b-b30830459d87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-839b-701a-ba52-25fb28adfecc.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a playground and seating area in the grassy yard.",
        "public_id": "019fce11-839b-701a-ba52-25fb28adfecc",
        "storage_key": "property/6767906449166356/019fce11-839b-701a-ba52-25fb28adfecc.webp",
        "width": 1024,
        "height": 575
      },
      "title": "Community",
      "description": "Exterior view of a brick apartment building with a large grassy lawn and a children’s playground, illustrating the community outdoor space.",
      "link": "false",
      "alt_text": "Exterior view of a brick apartment building with a grassy lawn and a playground at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/cca7cfe4ae7602c15c0915036fea56ec.png"
    },
    {
      "id": "custom_301166eb-3ce0-48be-be9b-e9ceb6e5b8de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8714-75ea-a8de-d9521f4c6b96.webp",
      "image_media": {
        "alt_text": "Exterior building entrance with manicured landscaping.",
        "public_id": "019fce11-8714-75ea-a8de-d9521f4c6b96",
        "storage_key": "property/6767906449166356/019fce11-8714-75ea-a8de-d9521f4c6b96.webp",
        "width": 2690,
        "height": 1796
      },
      "title": "Community",
      "description": "Exterior view of a brick apartment building with balconies and manicured landscaping.",
      "link": "false",
      "alt_text": "Exterior view of a two-story brick apartment building with a central glass entry and landscaped shrubs at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/5767906449162442/6767906449166356/4753005f8665e29ed6a5d5d8b702f3ad.webp"
    },
    {
      "id": "custom_d0b29571-754d-4d51-82d7-418ca78421f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Bird's-eye view of a residential apartment community with low-rise buildings, a central pool, and ample parking.",
      "link": "false",
      "alt_text": "Aerial view of a large apartment community with a central pool and green lawns at The Ridge Apartments in Hagerstown, MD",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/0c485807/dms3rep/multi/62e50b52437ae13d40a4d14a8af1f357-4b92adbc.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1979ebdf-9875-4c16-9214-63c4a4fe599d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hub City Diner",
      "poi_type": "Restaurants",
      "poi_address": "190 Railway Ln, Hagerstown, MD 21740, USA",
      "poi_short_description": "Relaxed option serving American favorites, including omelets, pancakes, French toast and grits.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-c180-7344-aa01-4fdeba677cf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-c180-7344-aa01-4fdeba677cf8",
        "storage_key": "property/6767906449166356/019fce11-c180-7344-aa01-4fdeba677cf8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9258228082588681403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hub-city-diner",
      "poi_latitude": "39.6302603",
      "poi_longitude": "-77.7673796",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 240-707-6638",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ae63-7101-b904-9e4d6f6c1c08",
        "storage_key": "property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg2bC6STzyYkRu4Q-kGPVe4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7ec9541d-cd94-44ae-9b1f-6ccc9eef9660",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Buffalo Wild Wings",
      "poi_type": "Restaurants",
      "poi_address": "230 Railway Ln, Hagerstown, MD 21740, USA",
      "poi_short_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_long_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-c18b-7159-99ef-1abcae690cea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-c18b-7159-99ef-1abcae690cea",
        "storage_key": "property/6767906449166356/019fce11-c18b-7159-99ef-1abcae690cea.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.buffalowildwings.com/locations/us/md/hagerstown/230-railway-lane/sports-bar-1606/?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAxNjYxMTU5My03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16966495639003701648&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buffalo-wild-wings",
      "poi_latitude": "39.6302566",
      "poi_longitude": "-77.7710815",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 301-766-7250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ae63-7101-b904-9e4d6f6c1c08",
        "storage_key": "property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4d3NYvLyyYkRkKEHLuQZdes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fe7ddcfd-9b4c-4646-b22f-8efa42536fa2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Black Rock Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "17301 Valley Mall Rd, Hagerstown, MD 21740, USA",
      "poi_short_description": "Steakhouse where diners enjoy steaks served with sides plus seafood and burgers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-c272-73d3-b484-f07d56e72545.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-c272-73d3-b484-f07d56e72545",
        "storage_key": "property/6767906449166356/019fce11-c272-73d3-b484-f07d56e72545.webp",
        "width": 1280,
        "height": 1171
      },
      "poi_business_url": "https://www.blackrockrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17905402332507297893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-rock-bar--grill",
      "poi_latitude": "39.625243",
      "poi_longitude": "-77.7694485",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 240-850-3365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ae63-7101-b904-9e4d6f6c1c08",
        "storage_key": "property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKa0XAunzyYkRZViM9Y3EfPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6084536f-559b-49c2-9d43-802a29e346d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "The Meadows Original Frozen Custard",
      "poi_type": "Restaurants",
      "poi_address": "222 E Oak Ridge Dr, Hagerstown, MD 21740, USA",
      "poi_short_description": "Old-fashioned chain established in 1950 specializing in frozen custard cones, sundaes & shakes.",
      "poi_long_description": "Old-fashioned chain established in 1950 specializing in frozen custard cones, sundaes & shakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-c1e1-7469-8f06-c8cd1a8c5d14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-c1e1-7469-8f06-c8cd1a8c5d14",
        "storage_key": "property/6767906449166356/019fce11-c1e1-7469-8f06-c8cd1a8c5d14.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://meadowsfrozencustard.com/columns/hagerstown-md/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16808176232366985184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-meadows-original-frozen-custard",
      "poi_latitude": "39.6121176",
      "poi_longitude": "-77.7212679",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 301-790-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ae63-7101-b904-9e4d6f6c1c08",
        "storage_key": "property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw2F9Z5_tyYkR4M9l1DqjQuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fe6825f8-85b3-4ba4-953c-5e6072998469",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Colonial Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "14130 Pennsylvania Ave, Hagerstown, MD 21742, USA",
      "poi_short_description": "Relaxed, family-owned restaurant offering crab cakes, wings and burgers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-c81c-74c7-88d2-929d2de3408c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-c81c-74c7-88d2-929d2de3408c",
        "storage_key": "property/6767906449166356/019fce11-c81c-74c7-88d2-929d2de3408c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://colonialbargrill.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=1489006019529596838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colonial-bar--grill",
      "poi_latitude": "39.70205869999999",
      "poi_longitude": "-77.7226103",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 301-739-0667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ae2d-773c-87c9-56413e3772be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ae2d-773c-87c9-56413e3772be",
        "storage_key": "property/6767906449166356/019d026d-ae2d-773c-87c9-56413e3772be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRweUVGeSyYkRpt967hUDqhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2ef56f0a-e647-4f86-9ccc-ceeffe060ab5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Schulas Grill & Crab House",
      "poi_type": "Restaurants",
      "poi_address": "11205 John F Kennedy Dr, Hagerstown, MD 21742, USA",
      "poi_short_description": "Seafood & sandwiches are served in a straightforward setting with polished wood tables & a bar.",
      "poi_long_description": "Seafood & sandwiches are served in a straightforward setting with polished wood tables & a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-c817-757f-a833-379ade09d7e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-c817-757f-a833-379ade09d7e1",
        "storage_key": "property/6767906449166356/019fce11-c817-757f-a833-379ade09d7e1.webp",
        "width": 1262,
        "height": 837
      },
      "poi_business_url": "https://www.schulasgrillandcrab.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7678252327674371615&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schulas-grill--crab-house",
      "poi_latitude": "39.6227787",
      "poi_longitude": "-77.67593719999999",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 301-714-1397",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ae63-7101-b904-9e4d6f6c1c08",
        "storage_key": "property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3bM6n5TsyYkRH97Yls-hjmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2b6130fb-dfff-4c5f-8441-399f9bbfa711",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "El Eden Latin Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1201 Dual Hwy, Hagerstown, MD 21740, USA",
      "poi_short_description": "Casual eatery serving Salvadoran comfort food such as pupusas in a family-friendly atmosphere.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-c8cb-759f-8fdd-5c770fdf94a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-c8cb-759f-8fdd-5c770fdf94a3",
        "storage_key": "property/6767906449166356/019fce11-c8cb-759f-8fdd-5c770fdf94a3.webp",
        "width": 1280,
        "height": 578
      },
      "poi_business_url": "https://eledenrestaurantmd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16631565416503807622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-eden-latin-restaurant",
      "poi_latitude": "39.629805",
      "poi_longitude": "-77.7014545",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 301-739-0463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ae63-7101-b904-9e4d6f6c1c08",
        "storage_key": "property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRx61aR7tyYkRho5h5aAwz-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e2d157e8-adde-4fe0-95ae-38bd37b513ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Los Amigos Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "29 N Burhans Blvd, Hagerstown, MD 21740, USA",
      "poi_short_description": "Mexican restaurant with an orange-painted interior plating hearty burritos, tacos, fajitas & more.",
      "poi_long_description": "Mexican restaurant with an orange-painted interior plating hearty burritos, tacos, fajitas & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-ca5d-7158-a793-d16f4da8906a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-ca5d-7158-a793-d16f4da8906a",
        "storage_key": "property/6767906449166356/019fce11-ca5d-7158-a793-d16f4da8906a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dinelosamigos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4510666781208663151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-amigos-mexican-restaurant",
      "poi_latitude": "39.646156",
      "poi_longitude": "-77.726775",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 240-420-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ae63-7101-b904-9e4d6f6c1c08",
        "storage_key": "property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLYLWGEbtyYkRb9QY-okbmT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_96f0f948-6e1d-49ad-8502-8012ff1e17b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Byers Market",
      "poi_type": "Restaurants",
      "poi_address": "152 N Burhans Blvd, Hagerstown, MD 21740, USA",
      "poi_short_description": "Long-standing market and convenience store serving groceries, subs, and other eats, plus late-night hours.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-ce9e-765d-9118-14a954c779a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-ce9e-765d-9118-14a954c779a7",
        "storage_key": "property/6767906449166356/019fce11-ce9e-765d-9118-14a954c779a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/120925324623098?y_source=1_NDEzODI1NjEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14510955855012430440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "byers-market",
      "poi_latitude": "39.6470044",
      "poi_longitude": "-77.72509210000001",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 301-797-1224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ae63-7101-b904-9e4d6f6c1c08",
        "storage_key": "property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI5foY0jtyYkRaAJkwXdFYck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c4010e39-ad7d-4155-9315-30a4a3ef0c4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Baile Cask & Kettle",
      "poi_type": "Restaurants",
      "poi_address": "53 W Washington St, Hagerstown, MD 21740, USA",
      "poi_short_description": "American and Irish pub with a cozy vibe, serving brews, bagels and burgers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-cee8-7740-8baf-ee8d11654e52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-cee8-7740-8baf-ee8d11654e52",
        "storage_key": "property/6767906449166356/019fce11-cee8-7740-8baf-ee8d11654e52.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bagelsandbrews.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12062631856952281521&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baile-cask--kettle",
      "poi_latitude": "39.6422154",
      "poi_longitude": "-77.72194449999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 301-358-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ae2d-773c-87c9-56413e3772be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ae2d-773c-87c9-56413e3772be",
        "storage_key": "property/6767906449166356/019d026d-ae2d-773c-87c9-56413e3772be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3zJlIADtyYkRsYnzacMTZ6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_264f91d8-ae10-4fa2-b860-82824955eab4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Schmankerl Stube",
      "poi_type": "Restaurants",
      "poi_address": "58 S Potomac St, Hagerstown, MD 21740, USA",
      "poi_short_description": "Servers in traditional costume serve hearty Bavarian fare & beer at this long-running local fixture.",
      "poi_long_description": "Servers in traditional costume serve hearty Bavarian fare & beer at this long-running local fixture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-cfc4-7090-b19c-4dc85f498a92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-cfc4-7090-b19c-4dc85f498a92",
        "storage_key": "property/6767906449166356/019fce11-cfc4-7090-b19c-4dc85f498a92.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.schmankerlstube.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16766716589147374893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schmankerl-stube",
      "poi_latitude": "39.64076",
      "poi_longitude": "-77.7211252",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 301-797-3354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ae63-7101-b904-9e4d6f6c1c08",
        "storage_key": "property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJty3WSj_tyYkRLUXHaedXr-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fcc3d743-cbb1-46d9-9c93-a00e8a146b98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Next Chapter Cafe & Book Shop",
      "poi_type": "Restaurants",
      "poi_address": "137 W Washington St, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-d125-73ca-ad4f-e44bbc1cc26f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-d125-73ca-ad4f-e44bbc1cc26f",
        "storage_key": "property/6767906449166356/019fce11-d125-73ca-ad4f-e44bbc1cc26f.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5318365630120481348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "next-chapter-cafe--book-shop",
      "poi_latitude": "39.6434541",
      "poi_longitude": "-77.7236726",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ade5-770f-964d-f879e42f3cbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ade5-770f-964d-f879e42f3cbc",
        "storage_key": "property/6767906449166356/019d026d-ade5-770f-964d-f879e42f3cbc.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJRX7ZJADtyYkRRFL62Fyhzkk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3fc900c0-6713-4623-9f12-4d347d098f4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Antietam Brewery",
      "poi_type": "Restaurants",
      "poi_address": "140 Western Maryland Pkwy ste a, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-d531-718c-9a8f-95efa3bd2353.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-d531-718c-9a8f-95efa3bd2353",
        "storage_key": "property/6767906449166356/019fce11-d531-718c-9a8f-95efa3bd2353.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.antietambrewery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12737398265411998891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "antietam-brewery",
      "poi_latitude": "39.6400024",
      "poi_longitude": "-77.7607797",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 240-513-4490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_sokL3yyYkRqxSPnDxUxLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eabf068c-630d-4165-9dd1-60fb005b5a6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "River Bottom Roasters",
      "poi_type": "Restaurants",
      "poi_address": "10212 Governor Lane Boulevard #1008, Williamsport, MD 21795, USA",
      "poi_short_description": "Coffee roaster offering a variety of specialty espresso drinks (fair-trade, oatmilk).",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-d5a4-710a-b688-142dfa07a519.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-d5a4-710a-b688-142dfa07a519",
        "storage_key": "property/6767906449166356/019fce11-d5a4-710a-b688-142dfa07a519.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://riverbottomroasters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10180222809116383139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-bottom-roasters",
      "poi_latitude": "39.5946811",
      "poi_longitude": "-77.8064237",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 240-850-3121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ade5-770f-964d-f879e42f3cbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ade5-770f-964d-f879e42f3cbc",
        "storage_key": "property/6767906449166356/019d026d-ade5-770f-964d-f879e42f3cbc.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ76ihLb7tyYkRoxe2L7VqR40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_da335ad6-165d-45fc-acf6-60cb5ee73b66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hub Pub",
      "poi_type": "Restaurants",
      "poi_address": "49 Eastern Blvd N, Hagerstown, MD 21740, USA",
      "poi_short_description": "Relaxed venue serving specialty burgers & other pub grub, plus local beers, in convivial surrounds.",
      "poi_long_description": "Relaxed venue serving specialty burgers & other pub grub, plus local beers, in convivial surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-d69c-74fa-a9c8-bf106cf7f963.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-d69c-74fa-a9c8-bf106cf7f963",
        "storage_key": "property/6767906449166356/019fce11-d69c-74fa-a9c8-bf106cf7f963.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://hub-pub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6014337200536034052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hub-pub",
      "poi_latitude": "39.633603",
      "poi_longitude": "-77.699894",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 301-791-5915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ae63-7101-b904-9e4d6f6c1c08",
        "storage_key": "property/6767906449166356/019d026d-ae63-7101-b904-9e4d6f6c1c08.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT1DbBSDtyYkRBBtejdE3d1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a4d2e2a5-e791-43b8-bd78-480718c4a9c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Oak Ridge Terrace",
      "poi_type": "Shopping",
      "poi_address": "13 E Oak Ridge Dr, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-d78a-763a-91af-5e9ca0978406.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-d78a-763a-91af-5e9ca0978406",
        "storage_key": "property/6767906449166356/019fce11-d78a-763a-91af-5e9ca0978406.webp",
        "width": 1249,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6594704008118254519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-ridge-terrace",
      "poi_latitude": "39.6118957",
      "poi_longitude": "-77.7291889",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b383-70b8-b52f-ebeccaef7c7d",
        "storage_key": "property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_zTxTgDtyYkRt7u76loYhVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b4a5280e-f5cd-401f-b937-c07c55fb5b83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hagerstown Premium Outlets",
      "poi_type": "Shopping",
      "poi_address": "495 Premium Outlets Blvd, Hagerstown, MD 21740, USA",
      "poi_short_description": "Village-feel outlet mall, eatery-equipped, outdoor-focused shopping venue featuring factory stores for name-brand apparel, accessories and home goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-db6e-770d-bd32-4fa094be8db9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-db6e-770d-bd32-4fa094be8db9",
        "storage_key": "property/6767906449166356/019fce11-db6e-770d-bd32-4fa094be8db9.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/hagerstown",
      "poi_directions_map_url": "https://maps.google.com/?cid=4191050910875414299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagerstown-premium-outlets",
      "poi_latitude": "39.6080927",
      "poi_longitude": "-77.7331293",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 301-790-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b383-70b8-b52f-ebeccaef7c7d",
        "storage_key": "property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlQIjWoXtyYkRG29OKpmaKTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_35ea88c2-df56-4e94-a035-20638feb56f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Valley Mall",
      "poi_type": "Shopping",
      "poi_address": "17301 Valley Mall Rd, Hagerstown, MD 21740, USA",
      "poi_short_description": "Big mall offering department stores, diverse\nretailers, a theater with stadium seating & an arcade.",
      "poi_long_description": "Big mall offering department stores, diverse\nretailers, a theater with stadium seating & an arcade.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-dce4-7418-9e0a-009f2c187791.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-dce4-7418-9e0a-009f2c187791",
        "storage_key": "property/6767906449166356/019fce11-dce4-7418-9e0a-009f2c187791.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "https://shopthevalleymall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18411761373766768461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-mall",
      "poi_latitude": "39.6237752",
      "poi_longitude": "-77.77044719999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 301-582-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b383-70b8-b52f-ebeccaef7c7d",
        "storage_key": "property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJARdv6fTyyYkRTVegdGu3g_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d90feda2-c0d9-41b2-a95d-a022eba54ef7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Old Orchard Shopping Center",
      "poi_type": "Shopping",
      "poi_address": "17619 Virginia Ave, Hagerstown, MD 21740, USA",
      "poi_short_description": "Flea market featuring a pawnshop, plus a post office and a Chinese restaurant.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-dd7f-71ee-9f77-7ccb952e7847.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-dd7f-71ee-9f77-7ccb952e7847",
        "storage_key": "property/6767906449166356/019fce11-dd7f-71ee-9f77-7ccb952e7847.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5790768588978533222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-orchard-shopping-center",
      "poi_latitude": "39.6203312",
      "poi_longitude": "-77.75710959999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b383-70b8-b52f-ebeccaef7c7d",
        "storage_key": "property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoc5cDIjyyYkRZjOO0lnxXFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_29f7a4f6-1571-4dbf-8359-06dd3f305494",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping",
      "poi_address": "565 Dual Hwy, Hagerstown, MD 21740, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-ddae-727a-9a58-8875207b0eae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-ddae-727a-9a58-8875207b0eae",
        "storage_key": "property/6767906449166356/019fce11-ddae-727a-9a58-8875207b0eae.webp",
        "width": 474,
        "height": 355
      },
      "poi_business_url": "https://stores.aldi.us/md/hagerstown/565-dual-highway?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=17839956569338876333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "39.6360196",
      "poi_longitude": "-77.7094193",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b382-7488-8bbc-9bd4b426d01f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b382-7488-8bbc-9bd4b426d01f",
        "storage_key": "property/6767906449166356/019d026d-b382-7488-8bbc-9bd4b426d01f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8yeuCLtyYkRrRHXy_pBlPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_77d817f2-f20f-4640-8775-d3f75b65cc94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Lidl",
      "poi_type": "Shopping",
      "poi_address": "733 Dual Hwy, Hagerstown, MD 21740, USA",
      "poi_short_description": "Discount supermarket chain, sourcing bakery goodies, imported cheeses, European delicacies and other groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-e190-766c-ac6f-241bbcdeb6d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-e190-766c-ac6f-241bbcdeb6d0",
        "storage_key": "property/6767906449166356/019fce11-e190-766c-ac6f-241bbcdeb6d0.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.lidl.com/stores/US01285",
      "poi_directions_map_url": "https://maps.google.com/?cid=15601141487668138741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lidl",
      "poi_latitude": "39.6347973",
      "poi_longitude": "-77.7065872",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 888-654-3515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b382-7488-8bbc-9bd4b426d01f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b382-7488-8bbc-9bd4b426d01f",
        "storage_key": "property/6767906449166356/019d026d-b382-7488-8bbc-9bd4b426d01f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYwUDCX3tyYkR9ZIRT4Zjgtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fd74444b-dc2f-41a2-8fed-4a99dbe3e696",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Weis Markets",
      "poi_type": "Shopping",
      "poi_address": "12817 Shank Farm Way, Hagerstown, MD 21742, USA",
      "poi_short_description": "Clean grocery store chain stocked with a wide variety of fresh produce (including organic options), deli items, bakery goods and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-e30a-7118-ad0a-9ebdac3e5ee2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-e30a-7118-ad0a-9ebdac3e5ee2",
        "storage_key": "property/6767906449166356/019fce11-e30a-7118-ad0a-9ebdac3e5ee2.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.weismarkets.com/stores#/4285",
      "poi_directions_map_url": "https://maps.google.com/?cid=3967625401724863938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "weis-markets",
      "poi_latitude": "39.6654418",
      "poi_longitude": "-77.6974518",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 301-665-9485",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b382-7488-8bbc-9bd4b426d01f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b382-7488-8bbc-9bd4b426d01f",
        "storage_key": "property/6767906449166356/019d026d-b382-7488-8bbc-9bd4b426d01f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdf3EuieTyYkRwoWgD0jWDzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_72e636c5-8860-4dee-9b3f-97d4cb9b8bb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping",
      "poi_address": "17850 Garland Groh Blvd, Hagerstown, MD 21740, USA",
      "poi_short_description": "Chain store stocking housewares, electronics and apparel, plus some groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-e3e4-710d-ab6d-4e0d985bae33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-e3e4-710d-ab6d-4e0d985bae33",
        "storage_key": "property/6767906449166356/019fce11-e3e4-710d-ab6d-4e0d985bae33.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1674-hagerstown-md/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6482048409208030348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "39.6581445",
      "poi_longitude": "-77.749112",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 301-714-1373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b383-70b8-b52f-ebeccaef7c7d",
        "storage_key": "property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLRNfTJLyyYkRjAS7T6_c9Fk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_15e82a1e-cea0-4aad-9312-5b6972f11eeb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Sheetz",
      "poi_type": "Shopping",
      "poi_address": "1333 Dual Hwy, Hagerstown, MD 21740, USA",
      "poi_short_description": "Chain offering fuel & familiar convenience goods, including packaged snacks, drinks & takeaway fare.",
      "poi_long_description": "Chain offering fuel & familiar convenience goods, including packaged snacks, drinks & takeaway fare.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://orders.sheetz.com/#/main/location/store/818",
      "poi_directions_map_url": "https://maps.google.com/?cid=17127740556687167226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sheetz",
      "poi_latitude": "39.6268379",
      "poi_longitude": "-77.6995771",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 240-469-4520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b3b7-751d-89e6-a891c955e479.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b3b7-751d-89e6-a891c955e479",
        "storage_key": "property/6767906449166356/019d026d-b3b7-751d-89e6-a891c955e479.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJy9wyObztyYkR-s5jJkr1se0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_50c3dd3f-4101-4619-b6cb-2063374a113d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Shopping",
      "poi_address": "1631 Dual Hwy, Hagerstown, MD 21740, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-e497-73f9-a103-ead4de4656df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-e497-73f9-a103-ead4de4656df",
        "storage_key": "property/6767906449166356/019fce11-e497-73f9-a103-ead4de4656df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1631+dual+hwy-hagerstown-md-21740/id=13893",
      "poi_directions_map_url": "https://maps.google.com/?cid=3583363140378930368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "39.6165194",
      "poi_longitude": "-77.6933171",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 240-313-9165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b546-71ee-a76a-bb7dbf39d403.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b546-71ee-a76a-bb7dbf39d403",
        "storage_key": "property/6767906449166356/019d026d-b546-71ee-a76a-bb7dbf39d403.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCcBzTPnsyYkRwKyDa8qpujE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3b043fd9-cd36-47e2-8ec4-0a570c9ffa27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Fountain Rock Elementary School",
      "poi_type": "Education",
      "poi_address": "17145 Lappans Rd, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://wcpsmd.com/schools/elementary-schools/fountain-rock-elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=346275104630538165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fountain-rock-elementary-school",
      "poi_latitude": "39.5707375",
      "poi_longitude": "-77.77302",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 301-766-8146",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b81c-709b-9a5d-e3a33005e0bf",
        "storage_key": "property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5Ty4wI3xyYkRtX8Qfl83zgQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_44bc3753-0d6a-44f1-a2d6-b2dcdb44a196",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Springfield Middle School",
      "poi_type": "Education",
      "poi_address": "334 E Sunset Ave, Williamsport, MD 21795, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-e7cb-76e3-ae32-27f71fef0d47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-e7cb-76e3-ae32-27f71fef0d47",
        "storage_key": "property/6767906449166356/019fce11-e7cb-76e3-ae32-27f71fef0d47.webp",
        "width": 1280,
        "height": 558
      },
      "poi_business_url": "http://wcpsmd.com/schools/middle-schools/springfield-middle",
      "poi_directions_map_url": "https://maps.google.com/?cid=15534477935778478476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "springfield-middle-school",
      "poi_latitude": "39.5935921",
      "poi_longitude": "-77.8116234",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 301-766-8389",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b81c-709b-9a5d-e3a33005e0bf",
        "storage_key": "property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2Q8SO93zyYkRjDk4nWCNldc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_98bd3e50-1941-4dee-8221-f2a05b60b1b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Williamsport High School",
      "poi_type": "Education",
      "poi_address": "5 S Clifton Dr, Williamsport, MD 21795, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-e865-72e8-b443-d54194ab5001.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-e865-72e8-b443-d54194ab5001",
        "storage_key": "property/6767906449166356/019fce11-e865-72e8-b443-d54194ab5001.webp",
        "width": 512,
        "height": 300
      },
      "poi_business_url": "http://wcpsmd.com/schools/high-schools/williamsport-high",
      "poi_directions_map_url": "https://maps.google.com/?cid=4154343206794003529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "williamsport-high-school",
      "poi_latitude": "39.596956",
      "poi_longitude": "-77.81003",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 301-766-8423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b81c-709b-9a5d-e3a33005e0bf",
        "storage_key": "property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw90Wp8PzyYkRSYQDzCIxpzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_15c07dd2-ec96-472c-be27-770f7fec7675",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Pangborn Elementary School",
      "poi_type": "Education",
      "poi_address": "195 Pangborn Blvd, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://wcpsmd.com/schools/elementary-schools/pangborn-elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=13051309444596381566&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pangborn-elementary-school",
      "poi_latitude": "39.6367413",
      "poi_longitude": "-77.7010787",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 301-766-8282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b81c-709b-9a5d-e3a33005e0bf",
        "storage_key": "property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrfSstiDtyYkRfjfegsqQH7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_04f867d2-d425-4614-ad1f-23c243366d77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Lincolnshire Elementary",
      "poi_type": "Education",
      "poi_address": "17545 Lincolnshire Rd, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://wcpsmd.com/schools/elementary-schools/lincolnshire-elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=14185087793546473737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lincolnshire-elementary",
      "poi_latitude": "39.6173764",
      "poi_longitude": "-77.7590578",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 301-766-8206",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b81c-709b-9a5d-e3a33005e0bf",
        "storage_key": "property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrzJA-mLyyYkRCTERQjGO28Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fd10dd6c-6a2c-4e71-b2d7-4552611338df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Salem Avenue Elementary School",
      "poi_type": "Education",
      "poi_address": "1323 Salem Ave, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-e948-71b4-a7ae-6d16c90fc452.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-e948-71b4-a7ae-6d16c90fc452",
        "storage_key": "property/6767906449166356/019fce11-e948-71b4-a7ae-6d16c90fc452.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://wcpsmd.com/schools/elementary-schools/salem-avenue-elementary",
      "poi_directions_map_url": "https://maps.google.com/?cid=10875627788746990232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salem-avenue-elementary-school",
      "poi_latitude": "39.65634379999999",
      "poi_longitude": "-77.73716069999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 301-766-8313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b81c-709b-9a5d-e3a33005e0bf",
        "storage_key": "property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-VqoS62SyYkRmKKhMdr97ZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6d406efb-bb8e-4146-811b-5d336df743a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hagerstown Children's School",
      "poi_type": "Education",
      "poi_address": "22 N Mulberry St Suite 200, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-eb9e-775f-a667-1d63bc9eef12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-eb9e-775f-a667-1d63bc9eef12",
        "storage_key": "property/6767906449166356/019fce11-eb9e-775f-a667-1d63bc9eef12.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://hagerstownchildrensschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=191777704436729127&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagerstown-childrens-school",
      "poi_latitude": "39.6404941",
      "poi_longitude": "-77.71549999999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 301-739-6886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b81c-709b-9a5d-e3a33005e0bf",
        "storage_key": "property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJASdvXz_tyYkRJ4XKXM5UqQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9e649478-63e9-437a-b555-93a60cd76d5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "St. Mary Catholic School",
      "poi_type": "Education",
      "poi_address": "218 W Washington St, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-ed8a-752f-9487-7ac8fa26260d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-ed8a-752f-9487-7ac8fa26260d",
        "storage_key": "property/6767906449166356/019fce11-ed8a-752f-9487-7ac8fa26260d.webp",
        "width": 900,
        "height": 943
      },
      "poi_business_url": "http://www.stmarycatholicschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=40437230848906952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-mary-catholic-school",
      "poi_latitude": "39.64440580000001",
      "poi_longitude": "-77.72490549999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 301-733-1184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b81c-709b-9a5d-e3a33005e0bf",
        "storage_key": "property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkS4JskftyYkRyBZzfHKpjwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7cb66095-a022-4e36-b4f0-44338ecdad03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Marshall Street School",
      "poi_type": "Education",
      "poi_address": "1350 Marshall St, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://wcpsmd.com/schools/special-programs/marshall-street-schooljob-development-program",
      "poi_directions_map_url": "https://maps.google.com/?cid=524977004622666023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshall-street-school",
      "poi_latitude": "39.661368",
      "poi_longitude": "-77.7312578",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 301-766-8214",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b81c-709b-9a5d-e3a33005e0bf",
        "storage_key": "property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQeaYPrKSyYkRJ1nI480XSQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2ddbf42f-c166-4c35-98be-e7b87ba687b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hagerstown Community College",
      "poi_type": "Education",
      "poi_address": "11400 Robinwood Dr, Hagerstown, MD 21742, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-ef3d-737d-917e-f72948890c16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-ef3d-737d-917e-f72948890c16",
        "storage_key": "property/6767906449166356/019fce11-ef3d-737d-917e-f72948890c16.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.hagerstowncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245405847857137301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagerstown-community-college",
      "poi_latitude": "39.63183069999999",
      "poi_longitude": "-77.6691925",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 240-500-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b81c-709b-9a5d-e3a33005e0bf",
        "storage_key": "property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ6ekwr3syYkRlQYwUtiPktM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c6f6fe57-8141-4308-9f4e-3f1871d42161",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Regal Valley Mall",
      "poi_type": "Entertainment",
      "poi_address": "17301 Valley Mall Rd, Hagerstown, MD 21740, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-eec7-700a-aa03-a6d09c256d35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-eec7-700a-aa03-a6d09c256d35",
        "storage_key": "property/6767906449166356/019fce11-eec7-700a-aa03-a6d09c256d35.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-valley-mall-screenx-1908?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7889356548298189825&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-valley-mall",
      "poi_latitude": "39.623978",
      "poi_longitude": "-77.77252",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b817-769e-801d-5d84f5c7abf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b817-769e-801d-5d84f5c7abf5",
        "storage_key": "property/6767906449166356/019d026d-b817-769e-801d-5d84f5c7abf5.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJhfFQN_TyyYkRASy3J_uffG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c06d55fa-9819-4ea8-a4fe-6b4bb89e42f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Warehouse Cinemas Leitersburg",
      "poi_type": "Entertainment",
      "poi_address": "20145 Leitersburg Pike, Hagerstown, MD 21742, USA",
      "poi_short_description": "10-screen cinema offering 4 VIP theaters with leather reclining seats.",
      "poi_long_description": "10-screen cinema offering 4 VIP theaters with leather reclining seats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-f25e-7202-8267-360a2164ca60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-f25e-7202-8267-360a2164ca60",
        "storage_key": "property/6767906449166356/019fce11-f25e-7202-8267-360a2164ca60.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://leitersburg.warehousecinemas.com/home/",
      "poi_directions_map_url": "https://maps.google.com/?cid=269339220887962181&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "warehouse-cinemas-leitersburg",
      "poi_latitude": "39.6838438",
      "poi_longitude": "-77.6683766",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 240-608-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b817-769e-801d-5d84f5c7abf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b817-769e-801d-5d84f5c7abf5",
        "storage_key": "property/6767906449166356/019d026d-b817-769e-801d-5d84f5c7abf5.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJiTsdppiTyYkRRYIbKZjivAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_57c48549-e45a-4ac7-9172-a60817f9d597",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Washington County Museum of Fine Arts",
      "poi_type": "Entertainment",
      "poi_address": "401 Museum Dr, Hagerstown, MD 21740, USA",
      "poi_short_description": "Changing exhibits of 7,000+ paintings & sculptures by global artists of the 18th-20th centuries.",
      "poi_long_description": "Changing exhibits of 7,000+ paintings & sculptures by global artists of the 18th-20th centuries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-f4ad-748b-8953-ff47294dba89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-f4ad-748b-8953-ff47294dba89",
        "storage_key": "property/6767906449166356/019fce11-f4ad-748b-8953-ff47294dba89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wcmfa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8356978858387118878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-county-museum-of-fine-arts",
      "poi_latitude": "39.6370417",
      "poi_longitude": "-77.7314889",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 301-739-5727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b923-7149-a43c-2a9befba7eab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b923-7149-a43c-2a9befba7eab",
        "storage_key": "property/6767906449166356/019d026d-b923-7149-a43c-2a9befba7eab.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJlxE4g0LtyYkRHhudmf7z-XM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d73873cf-152b-4808-abd3-3ebf010e2f00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "The Maryland Theatre",
      "poi_type": "Entertainment",
      "poi_address": "21 S Potomac St, Hagerstown, MD 21740, USA",
      "poi_short_description": "Built in 1915, this stately theater with balcony & box seats showcases a variety of performances.",
      "poi_long_description": "Built in 1915, this stately theater with balcony & box seats showcases a variety of performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-f490-71ab-bfc3-c0c1681b7a49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-f490-71ab-bfc3-c0c1681b7a49",
        "storage_key": "property/6767906449166356/019fce11-f490-71ab-bfc3-c0c1681b7a49.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.mdtheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1221713920999544161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-maryland-theatre",
      "poi_latitude": "39.6416254",
      "poi_longitude": "-77.72095759999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 301-790-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-7IOuTjtyYkRYdVTllZm9BA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bfeb1390-88e0-4e9a-9d82-11a616036f8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Washington County Playhouse Dinner Theater",
      "poi_type": "Entertainment",
      "poi_address": "44 N Potomac St Rear, Hagerstown, MD 21740, USA",
      "poi_short_description": "Intimate dinner theater featuring assorted plays & musicals, plus shows for children.",
      "poi_long_description": "Intimate dinner theater featuring assorted plays & musicals, plus shows for children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-f649-76bc-8894-f2145efccb02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-f649-76bc-8894-f2145efccb02",
        "storage_key": "property/6767906449166356/019fce11-f649-76bc-8894-f2145efccb02.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.washingtoncountyplayhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9222448587966991359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-county-playhouse-dinner-theater",
      "poi_latitude": "39.6427688",
      "poi_longitude": "-77.7189636",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 301-739-7469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqYYKATntyYkR_0sTzSC4_H8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_188607f5-0b76-42aa-979c-c087dcc192ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hagerstown Roundhouse Museum",
      "poi_type": "Entertainment",
      "poi_address": "296 S Burhans Blvd, Hagerstown, MD 21740, USA",
      "poi_short_description": "Model trains & restored engines tell the story of this enduring site's longtime railway history.",
      "poi_long_description": "Model trains & restored engines tell the story of this enduring site's longtime railway history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-f8e4-775f-99dd-f34d62f5dd80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-f8e4-775f-99dd-f34d62f5dd80",
        "storage_key": "property/6767906449166356/019fce11-f8e4-775f-99dd-f34d62f5dd80.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roundhouse.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4070219938600847329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagerstown-roundhouse-museum",
      "poi_latitude": "39.6427978",
      "poi_longitude": "-77.7341185",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 301-739-4665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b923-7149-a43c-2a9befba7eab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b923-7149-a43c-2a9befba7eab",
        "storage_key": "property/6767906449166356/019d026d-b923-7149-a43c-2a9befba7eab.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIz04UVvtyYkR4QcEHnhTfDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_897fc43f-ecea-45ad-bdd1-e046ed66ed18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Discovery Station At Hagerstown Inc",
      "poi_type": "Entertainment",
      "poi_address": "14326 Barrick Ave, Highfield-Cascade, MD 21719, USA",
      "poi_short_description": "Children's museum focused on science, technology & history with hands-on exhibits & school programs.",
      "poi_long_description": "Children's museum focused on science, technology & history with hands-on exhibits & school programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-fbac-7708-8a20-614c4a5f3ea4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-fbac-7708-8a20-614c4a5f3ea4",
        "storage_key": "property/6767906449166356/019fce11-fbac-7708-8a20-614c4a5f3ea4.webp",
        "width": 1280,
        "height": 815
      },
      "poi_business_url": "http://www.discoverystation.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1601702117094845238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-station-at-hagerstown-inc",
      "poi_latitude": "39.7067595",
      "poi_longitude": "-77.492603",
      "poi_miles_from_property": "17.8 mi",
      "poi_walking_minutes": "6 hours 46 mins",
      "poi_biking_minutes": "1 hour 56 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 301-790-0076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b923-7149-a43c-2a9befba7eab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b923-7149-a43c-2a9befba7eab",
        "storage_key": "property/6767906449166356/019d026d-b923-7149-a43c-2a9befba7eab.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJrydvekftyYkRNutt3ZZjOhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4083ac73-3557-4812-9cda-3dae3723b0f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hagerstown Aviation Museum",
      "poi_type": "Entertainment",
      "poi_address": "18450 Showalter Rd Bldg 8, Hagerstown, MD 21742, USA",
      "poi_short_description": "Museum-style collection with vintage planes, plus exhibits about Hagerstown aviation.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-fbdd-70e8-ac89-6c6fe6645c60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-fbdd-70e8-ac89-6c6fe6645c60",
        "storage_key": "property/6767906449166356/019fce11-fbdd-70e8-ac89-6c6fe6645c60.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.hagerstownaviationmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4753039785537767489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagerstown-aviation-museum",
      "poi_latitude": "39.7065859",
      "poi_longitude": "-77.72621319999999",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 301-733-8717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b923-7149-a43c-2a9befba7eab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b923-7149-a43c-2a9befba7eab",
        "storage_key": "property/6767906449166356/019d026d-b923-7149-a43c-2a9befba7eab.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJEUvNyUKSyYkRQQhHlIAw9kE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7e221456-ba93-4cbd-82c0-1a025c69ca03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hagerstown Speedway",
      "poi_type": "Entertainment",
      "poi_address": "15112 National Pike, Hagerstown, MD 21740, USA",
      "poi_short_description": "Auto racing center with a half-mile dirt track hosting spring & stock car series.",
      "poi_long_description": "Auto racing center with a half-mile dirt track hosting spring & stock car series.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-fc3a-702c-b0c0-bcc7da0d52b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-fc3a-702c-b0c0-bcc7da0d52b3",
        "storage_key": "property/6767906449166356/019fce11-fc3a-702c-b0c0-bcc7da0d52b3.webp",
        "width": 1280,
        "height": 474
      },
      "poi_business_url": "http://www.hagerstownspeedway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9739115465753374863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagerstown-speedway",
      "poi_latitude": "39.6597222",
      "poi_longitude": "-77.84388890000001",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 301-582-0640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJyw7aK_0yYkRjzC-gupJKIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7aebafe4-501f-446c-98ee-95016aa9c581",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Antietam National Battlefield Visitor Center",
      "poi_type": "Entertainment",
      "poi_address": "5831 Dunker Church Rd, Sharpsburg, MD 21782, USA",
      "poi_short_description": "Battlefield at the site of a major Civil War battle, offering a self-guided driving tour, ranger-led talks and a museum.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-ffdc-7560-ad48-207cd552b2db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-ffdc-7560-ad48-207cd552b2db",
        "storage_key": "property/6767906449166356/019fce11-ffdc-7560-ad48-207cd552b2db.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nps.gov/anti/planyourvisit/visitorcenters.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=14013559150674134462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "antietam-national-battlefield-visitor-center",
      "poi_latitude": "39.47419259999999",
      "poi_longitude": "-77.744526",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 301-432-5124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT69ET7DlyYkRvkXb7swpesI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6b2ff5fe-326b-4871-974e-ea02802da3cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Meritus Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "11116 Medical Campus Rd, Hagerstown, MD 21742, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-0254-76e5-8415-ca8503d398fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-0254-76e5-8415-ca8503d398fa",
        "storage_key": "property/6767906449166356/019fce12-0254-76e5-8415-ca8503d398fa.webp",
        "width": 962,
        "height": 1280
      },
      "poi_business_url": "http://www.meritushealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11059399238569098341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meritus-medical-center",
      "poi_latitude": "39.6228538",
      "poi_longitude": "-77.6848579",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 301-790-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ba60-71de-9757-855e431981ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ba60-71de-9757-855e431981ab",
        "storage_key": "property/6767906449166356/019d026d-ba60-71de-9757-855e431981ab.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJn3H43DjtyYkRZfwiJAPhepk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bde3a94a-0368-4272-9af2-165e3cc1a2a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "MedExpress Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1741 Dual Hwy, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-01af-7664-9a1d-54c0bee58e34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-01af-7664-9a1d-54c0bee58e34",
        "storage_key": "property/6767906449166356/019fce12-01af-7664-9a1d-54c0bee58e34.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "http://www.medexpress.com/?utm_campaign=MX_Brand_2021&utm_medium=NPS&utm_source=YEXT&utm_term=2021mgg2o3az19",
      "poi_directions_map_url": "https://maps.google.com/?cid=211550184399611185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medexpress-urgent-care",
      "poi_latitude": "39.6130941",
      "poi_longitude": "-77.69131469999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 304-225-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk8j4ivjsyYkRMaVOmcWT7wI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_af9c59bc-81b0-4ad6-8cc6-6d9008425c6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Meritus Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "11116 Medical Campus Rd Ste 2460, Hagerstown, MD 21742, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-025b-7379-a9e4-6347ffa3d890.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-025b-7379-a9e4-6347ffa3d890",
        "storage_key": "property/6767906449166356/019fce12-025b-7379-a9e4-6347ffa3d890.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mygnp.com/pharmacies/meritus-pharmacy-hagerstown-md-21742/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=2144145",
      "poi_directions_map_url": "https://maps.google.com/?cid=882550113576800488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meritus-medical-center",
      "poi_latitude": "39.6227761",
      "poi_longitude": "-77.6845337",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 301-790-9281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b546-71ee-a76a-bb7dbf39d403.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b546-71ee-a76a-bb7dbf39d403",
        "storage_key": "property/6767906449166356/019d026d-b546-71ee-a76a-bb7dbf39d403.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmabihnXtyYkR6NA5AKdyPww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bcfe0dba-1f4f-40a3-93e0-25e2d59a10d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1731 Dual Hwy, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-0728-752b-9479-606c912a17db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-0728-752b-9479-606c912a17db",
        "storage_key": "property/6767906449166356/019fce12-0728-752b-9479-606c912a17db.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/hagerstown-md-pharmacies/1731-dual-hwy-hagerstown-md-21740/storeid=3166?WT.mc_id=LS_GOOGLE_RX_3166",
      "poi_directions_map_url": "https://maps.google.com/?cid=2407439736466189488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.6135727",
      "poi_longitude": "-77.6935606",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 301-791-2852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b546-71ee-a76a-bb7dbf39d403.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b546-71ee-a76a-bb7dbf39d403",
        "storage_key": "property/6767906449166356/019d026d-b546-71ee-a76a-bb7dbf39d403.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxShrtfjsyYkRsCw6Zq_xaCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_17fe8465-9f4c-4d44-8a63-1eff36fff650",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1631 Dual Hwy, Hagerstown, MD 21740, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-07d7-77b1-a047-c86ff1382cd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-07d7-77b1-a047-c86ff1382cd1",
        "storage_key": "property/6767906449166356/019fce12-07d7-77b1-a047-c86ff1382cd1.webp",
        "width": 1280,
        "height": 879
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1631+dual+hwy-hagerstown-md-21740/id=13893",
      "poi_directions_map_url": "https://maps.google.com/?cid=57971024642321372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "39.6165355",
      "poi_longitude": "-77.6933967",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 240-313-9165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6VOfGjtyYkR3CsS-1b0zQA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0baacb3e-86c3-478d-a99e-a408ee10c9e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Health and Wellness",
      "poi_address": "17850 Garland Groh Blvd, Hagerstown, MD 21740, USA",
      "poi_short_description": "Chain store stocking housewares, electronics and apparel, plus some groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-e3e4-710d-ab6d-4e0d985bae33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-e3e4-710d-ab6d-4e0d985bae33",
        "storage_key": "property/6767906449166356/019fce11-e3e4-710d-ab6d-4e0d985bae33.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1674-hagerstown-md/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6482048409208030348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "39.6581445",
      "poi_longitude": "-77.749112",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 301-714-1373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b383-70b8-b52f-ebeccaef7c7d",
        "storage_key": "property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLRNfTJLyyYkRjAS7T6_c9Fk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_920f9f92-b744-457f-9cc2-8df296a9040f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "YMCA Hagerstown",
      "poi_type": "Health and Wellness",
      "poi_address": "1100 Eastern Blvd N, Hagerstown, MD 21742, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-08b3-7568-8993-33d411b253a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-08b3-7568-8993-33d411b253a3",
        "storage_key": "property/6767906449166356/019fce12-08b3-7568-8993-33d411b253a3.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://ymcahagerstown.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2518059215384675756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ymca-hagerstown",
      "poi_latitude": "39.6604234",
      "poi_longitude": "-77.691611",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 301-739-3990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHbg64y6TyYkRrAVn4IPx8SI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_14b6c3d2-c6b9-4c53-9c1e-c84f61363785",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hagerstown Sports Club and Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "20321 The Gardens, Hagerstown, MD 21742, USA",
      "poi_short_description": "Bright gym featuring classes and clean equipment as well as an outdoor pool and friendly service.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-08cf-711b-bf37-ec6c30374fad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-08cf-711b-bf37-ec6c30374fad",
        "storage_key": "property/6767906449166356/019fce12-08cf-711b-bf37-ec6c30374fad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://hagerstownsportsclubfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17290931611011600735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagerstown-sports-club-and-fitness",
      "poi_latitude": "39.624113",
      "poi_longitude": "-77.6772536",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 240-625-9474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwUe62ezsyYkRX1HrXbC69e8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f510bc85-830f-4096-bb87-19b4460eb0fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Onelife Fitness - Valley Mall",
      "poi_type": "Health and Wellness",
      "poi_address": "17301 Valley Mall Rd, Hagerstown, MD 21740, USA",
      "poi_short_description": "Chains featuring large, clean, well-equipped workout facilities, plus a pool, hot tub and personal trainers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-0d8c-72bd-b33f-1e42264dba8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-0d8c-72bd-b33f-1e42264dba8d",
        "storage_key": "property/6767906449166356/019fce12-0d8c-72bd-b33f-1e42264dba8d.webp",
        "width": 1079,
        "height": 1172
      },
      "poi_business_url": "https://www.onelifefitness.com/gyms/hagerstown",
      "poi_directions_map_url": "https://maps.google.com/?cid=7032603926842647593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "onelife-fitness---valley-mall",
      "poi_latitude": "39.6230234",
      "poi_longitude": "-77.77247609999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 301-733-0980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBfL5XmjzyYkRKSR52QLUmGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_60b76df4-094c-4054-821a-b0c41de100d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Sol Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "13512 Pennsylvania Ave, Hagerstown, MD 21742, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13511371367208194493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sol-yoga",
      "poi_latitude": "39.6848185",
      "poi_longitude": "-77.7210119",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__-jPe2SyYkRvRHUEqwIgrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8882a9de-9c13-4109-8772-672d891a79a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Fairgrounds Park",
      "poi_type": "Recreation",
      "poi_address": "351 N Cleveland Ave, Hagerstown, MD 21740, USA",
      "poi_short_description": "Urban park with a grandstand, playground & dog area, plus indoor & outdoor sports facilities.",
      "poi_long_description": "Urban park with a grandstand, playground & dog area, plus indoor & outdoor sports facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-0eab-750f-a89b-681550cf5d91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-0eab-750f-a89b-681550cf5d91",
        "storage_key": "property/6767906449166356/019fce12-0eab-750f-a89b-681550cf5d91.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hagerstownmd.org/314/Fairgrounds-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16622204667940647727&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairgrounds-park",
      "poi_latitude": "39.6456049",
      "poi_longitude": "-77.7065754",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 301-739-8577 ext. 169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-bbfb-768b-9828-1bc0fc1a2696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-bbfb-768b-9828-1bc0fc1a2696",
        "storage_key": "property/6767906449166356/019d026d-bbfb-768b-9828-1bc0fc1a2696.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9ZJkCS_tyYkRLzNxyBPvreY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fb3d5ce5-d9e9-4afc-9b30-c83a7be13aaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Pangborn Park",
      "poi_type": "Recreation",
      "poi_address": "591 Pangborn Blvd, Hagerstown, MD 21740, USA",
      "poi_short_description": "Tennis, softball, volleyball & lawn bowling can all be played at this city park with a pond.",
      "poi_long_description": "Tennis, softball, volleyball & lawn bowling can all be played at this city park with a pond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-0fbd-742c-b073-e36ef206342f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-0fbd-742c-b073-e36ef206342f",
        "storage_key": "property/6767906449166356/019fce12-0fbd-742c-b073-e36ef206342f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hagerstownmd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17623920626235848627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pangborn-park",
      "poi_latitude": "39.6489793",
      "poi_longitude": "-77.7000463",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 301-739-8577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-bbfb-768b-9828-1bc0fc1a2696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-bbfb-768b-9828-1bc0fc1a2696",
        "storage_key": "property/6767906449166356/019d026d-bbfb-768b-9828-1bc0fc1a2696.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDcopFyrtyYkRs7d3HG--lPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8c1a049d-399b-42e3-8220-ebb8af029765",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Mills Park",
      "poi_type": "Recreation",
      "poi_address": "Hagerstown, MD 21742, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.hagerstownmd.org/319/Mills-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16430190847895369758&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mills-park",
      "poi_latitude": "39.6634277",
      "poi_longitude": "-77.7097953",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-bbfb-768b-9828-1bc0fc1a2696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-bbfb-768b-9828-1bc0fc1a2696",
        "storage_key": "property/6767906449166356/019d026d-bbfb-768b-9828-1bc0fc1a2696.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAPNCSyYkRHniteIbDA-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d09dffa5-3cfe-4762-ac78-328cad8ac0da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Kiwanis Park",
      "poi_type": "Recreation",
      "poi_address": "371 Dynasty Dr, Hagerstown, MD 21742, USA",
      "poi_short_description": "Peaceful park featuring kayak access and a gazebo on Antietam Creek.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-1052-745b-abb0-9276b8e86a9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-1052-745b-abb0-9276b8e86a9f",
        "storage_key": "property/6767906449166356/019fce12-1052-745b-abb0-9276b8e86a9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hagerstownmd.org/kiwanispark",
      "poi_directions_map_url": "https://maps.google.com/?cid=16674530439602548302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiwanis-park",
      "poi_latitude": "39.6387715",
      "poi_longitude": "-77.6907983",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-bbfb-768b-9828-1bc0fc1a2696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-bbfb-768b-9828-1bc0fc1a2696",
        "storage_key": "property/6767906449166356/019d026d-bbfb-768b-9828-1bc0fc1a2696.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHdBHxgPtyYkRTq7y4BbVZ-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_260619f8-55b9-4ad2-ae8f-5b6ad33ee630",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Wheaton Park",
      "poi_type": "Recreation",
      "poi_address": "120 Charles St, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6808098547881111396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wheaton-park",
      "poi_latitude": "39.6499449",
      "poi_longitude": "-77.7189178",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-bbfb-768b-9828-1bc0fc1a2696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-bbfb-768b-9828-1bc0fc1a2696",
        "storage_key": "property/6767906449166356/019d026d-bbfb-768b-9828-1bc0fc1a2696.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqjzbtyYkRZG9O9o45e14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_237f7dba-cc4b-4683-8239-7c23f2c25e7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hager Park",
      "poi_type": "Recreation",
      "poi_address": "276 E Memorial Blvd, Hagerstown, MD 21740, USA",
      "poi_short_description": "Green space offering a baseball field, picnic pavilion & BBQs along with play equipment & restrooms.",
      "poi_long_description": "Green space offering a baseball field, picnic pavilion & BBQs along with play equipment & restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-13cc-708c-8d94-fd96346f0411.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-13cc-708c-8d94-fd96346f0411",
        "storage_key": "property/6767906449166356/019fce12-13cc-708c-8d94-fd96346f0411.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hagerstownmd.org/index.aspx?nid=145",
      "poi_directions_map_url": "https://maps.google.com/?cid=12400211857291103905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hager-park",
      "poi_latitude": "39.6329741",
      "poi_longitude": "-77.71501429999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 301-739-8577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-bbfb-768b-9828-1bc0fc1a2696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-bbfb-768b-9828-1bc0fc1a2696",
        "storage_key": "property/6767906449166356/019d026d-bbfb-768b-9828-1bc0fc1a2696.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG71vdBbtyYkRoU5sLfxmFqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8ce8bd5f-e89e-4e74-92ee-5fd75752b49c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Washington County Museum of Fine Arts",
      "poi_type": "Recreation",
      "poi_address": "401 Museum Dr, Hagerstown, MD 21740, USA",
      "poi_short_description": "Changing exhibits of 7,000+ paintings & sculptures by global artists of the 18th-20th centuries.",
      "poi_long_description": "Changing exhibits of 7,000+ paintings & sculptures by global artists of the 18th-20th centuries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-f4ad-748b-8953-ff47294dba89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-f4ad-748b-8953-ff47294dba89",
        "storage_key": "property/6767906449166356/019fce11-f4ad-748b-8953-ff47294dba89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wcmfa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8356978858387118878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-county-museum-of-fine-arts",
      "poi_latitude": "39.6370417",
      "poi_longitude": "-77.7314889",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 301-739-5727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b923-7149-a43c-2a9befba7eab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b923-7149-a43c-2a9befba7eab",
        "storage_key": "property/6767906449166356/019d026d-b923-7149-a43c-2a9befba7eab.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJlxE4g0LtyYkRHhudmf7z-XM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c6bb8ab2-5ba7-4851-ab34-50cd62de9e1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "C & O Canal National Historical Park Headquarters",
      "poi_type": "Recreation",
      "poi_address": "142 W Potomac St, Williamsport, MD 21795, USA",
      "poi_short_description": "Canal trail stretching 184 miles from DC to Cumberland and beyond, open to bikers and hikers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-1613-725f-9df3-903fbb39a965.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-1613-725f-9df3-903fbb39a965",
        "storage_key": "property/6767906449166356/019fce12-1613-725f-9df3-903fbb39a965.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.nps.gov/choh/planyourvisit/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17026091727025371508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "c--o-canal-national-historical-park-headquarters",
      "poi_latitude": "39.5999856",
      "poi_longitude": "-77.8253907",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 202-653-5190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKXEAhUu2t4kRdHmQtjfUSOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_db891541-de81-400f-974d-bc13b3f22047",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Greenbrier State Park",
      "poi_type": "Recreation",
      "poi_address": "21843 National Pike, Boonsboro, MD 21713, USA",
      "poi_short_description": "Recreational options include fishing & swimming in the man-made lake with a small, sandy beach.",
      "poi_long_description": "Recreational options include fishing & swimming in the man-made lake with a small, sandy beach.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-17ea-73c8-93c3-31e46ef63900.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-17ea-73c8-93c3-31e46ef63900",
        "storage_key": "property/6767906449166356/019fce12-17ea-73c8-93c3-31e46ef63900.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://dnr.maryland.gov/publiclands/Pages/western/greenbrier.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15417511570388720460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenbrier-state-park",
      "poi_latitude": "39.5377873",
      "poi_longitude": "-77.6218342",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 301-791-4767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-bbfb-768b-9828-1bc0fc1a2696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-bbfb-768b-9828-1bc0fc1a2696",
        "storage_key": "property/6767906449166356/019d026d-bbfb-768b-9828-1bc0fc1a2696.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJazAx9hDpyYkRTJt-eRYB9tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4dae5fe3-adce-415a-8157-e4acac58e6ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Washington County Transit",
      "poi_type": "Transportation",
      "poi_address": "1000 W Washington St, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15877090110663444331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-county-transit",
      "poi_latitude": "39.6482366",
      "poi_longitude": "-77.7389938",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-rzLwDtyYkRa0f20FXBVtw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_48213bb3-a843-42d2-8e7a-b9c4a5c52aad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Greyhound: Bus Stop",
      "poi_type": "Transportation",
      "poi_address": "123 W Franklin St, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-1852-7286-8131-3f708de129e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-1852-7286-8131-3f708de129e6",
        "storage_key": "property/6767906449166356/019fce12-1852-7286-8131-3f708de129e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greyhound.com/bus/hagerstown-md/hagerstown-washington-co-trans-ctr?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8282770038204057327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-stop",
      "poi_latitude": "39.6445368",
      "poi_longitude": "-77.7225508",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 301-687-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ80_vi0ftyYkR78ZmO3dP8nI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9a0ed22b-a642-43fa-9546-e6a9ea7e36fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hagerstown Regional Airport",
      "poi_type": "Transportation",
      "poi_address": "18434 Showalter Rd, Hagerstown, MD 21742, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-1a0d-704b-972e-3f224dc55935.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-1a0d-704b-972e-3f224dc55935",
        "storage_key": "property/6767906449166356/019fce12-1a0d-704b-972e-3f224dc55935.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.flyhagerstown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11200584904058129096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagerstown-regional-airport",
      "poi_latitude": "39.7053895",
      "poi_longitude": "-77.73100180000002",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 240-313-2777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-bc42-754a-80a0-039295c488bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-bc42-754a-80a0-039295c488bb",
        "storage_key": "property/6767906449166356/019d026d-bc42-754a-80a0-039295c488bb.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJcXMOoW-SyYkRyMr8gqB4cJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4fd554a7-c31c-409a-ac39-df9ec677215b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Downsville Pike Park & Ride",
      "poi_type": "Transportation",
      "poi_address": "10704 Downsville Pike, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://roads.maryland.gov/mdotsha/pages/index.aspx?PageId=248",
      "poi_directions_map_url": "https://maps.google.com/?cid=6073406902243025025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downsville-pike-park--ride",
      "poi_latitude": "39.6077415",
      "poi_longitude": "-77.75414599999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 410-539-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-be17-75bb-8c92-d02bf94205af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-be17-75bb-8c92-d02bf94205af",
        "storage_key": "property/6767906449166356/019d026d-be17-75bb-8c92-d02bf94205af.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJg0VTYXDyyYkRgeCZOGYTSVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_815bb5d7-a93d-4f36-9831-3ead2bbf6d8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "East Hagerstown Park & Ride",
      "poi_type": "Transportation",
      "poi_address": "Auto Pl, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://roads.maryland.gov/mdotsha/pages/index.aspx?PageId=248",
      "poi_directions_map_url": "https://maps.google.com/?cid=4433185793911471013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-hagerstown-park--ride",
      "poi_latitude": "39.5975397",
      "poi_longitude": "-77.6801232",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-be17-75bb-8c92-d02bf94205af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-be17-75bb-8c92-d02bf94205af",
        "storage_key": "property/6767906449166356/019d026d-be17-75bb-8c92-d02bf94205af.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJzyDOIkLsyYkRpbtm1f3WhT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_67760dd0-ebfd-4b2a-81a6-4b7d7fa8eed2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Maryland Motor Vehicle Administration",
      "poi_type": "Transportation",
      "poi_address": "18306 Col Henry K Douglas Dr, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4993711416802606388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maryland-motor-vehicle-administration",
      "poi_latitude": "39.6028542",
      "poi_longitude": "-77.73253009999999",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 410-539-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-be17-75bb-8c92-d02bf94205af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-be17-75bb-8c92-d02bf94205af",
        "storage_key": "property/6767906449166356/019d026d-be17-75bb-8c92-d02bf94205af.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJv7ImwZHtyYkRNP1UZRM6TUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_40b1cada-f472-40b2-b137-284e698cfd37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Mapleville Road Park and Ride",
      "poi_type": "Transportation",
      "poi_address": "10037 Mapleville Rd, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-1d4a-7450-9dd2-b1b94e419cf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-1d4a-7450-9dd2-b1b94e419cf5",
        "storage_key": "property/6767906449166356/019fce12-1d4a-7450-9dd2-b1b94e419cf5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://roads.maryland.gov/mdotsha/pages/index.aspx?PageId=248",
      "poi_directions_map_url": "https://maps.google.com/?cid=3214729122925700956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mapleville-road-park-and-ride",
      "poi_latitude": "39.5888517",
      "poi_longitude": "-77.63626479999999",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-be17-75bb-8c92-d02bf94205af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-be17-75bb-8c92-d02bf94205af",
        "storage_key": "property/6767906449166356/019d026d-be17-75bb-8c92-d02bf94205af.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJPWwBeZPryYkRXOcW3RoDnSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5e336759-c535-47eb-bfef-ae466d0668df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Highway Administration",
      "poi_type": "Transportation",
      "poi_address": "18320 Col Henry K Douglas Dr, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11497718435062310592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highway-administration",
      "poi_latitude": "39.6037992",
      "poi_longitude": "-77.7352829",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 301-791-4790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-be9c-758a-bfe9-250f916f46c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-be9c-758a-bfe9-250f916f46c5",
        "storage_key": "property/6767906449166356/019d026d-be9c-758a-bfe9-250f916f46c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPbH8SY7tyYkRwGZZyf8ZkJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e1a7e289-3e31-4e02-bea2-7f3d28aa23bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Brunswick MD",
      "poi_type": "Transportation",
      "poi_address": "Brunswick, MD 21716, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-1edb-76f3-b85a-e0ca2653fdc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-1edb-76f3-b85a-e0ca2653fdc6",
        "storage_key": "property/6767906449166356/019fce12-1edb-76f3-b85a-e0ca2653fdc6.webp",
        "width": 1280,
        "height": 807
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13485256929884322953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brunswick-md",
      "poi_latitude": "39.3121079",
      "poi_longitude": "-77.6274439",
      "poi_miles_from_property": "26.3 mi",
      "poi_walking_minutes": "9 hours 36 mins",
      "poi_biking_minutes": "2 hours 25 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-bfd1-75de-8bf0-9fca50207735.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-bfd1-75de-8bf0-9fca50207735",
        "storage_key": "property/6767906449166356/019d026d-bfd1-75de-8bf0-9fca50207735.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8uNCCMetokRiTyh0rpBJbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1c5fc907-ee2f-44f8-ae8d-79650d404590",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Martinsburg, West Virginia",
      "poi_type": "Transportation",
      "poi_address": "229 E Martin St, Martinsburg, WV 25401, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-2164-705f-a7fa-f7a11b2d6a7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-2164-705f-a7fa-f7a11b2d6a7f",
        "storage_key": "property/6767906449166356/019fce12-2164-705f-a7fa-f7a11b2d6a7f.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=MRB",
      "poi_directions_map_url": "https://maps.google.com/?cid=5596020474514036754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "martinsburg-west-virginia",
      "poi_latitude": "39.4586385",
      "poi_longitude": "-77.9608907",
      "poi_miles_from_property": "26.2 mi",
      "poi_walking_minutes": "9 hours 32 mins",
      "poi_biking_minutes": "2 hours 8 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-bfd1-75de-8bf0-9fca50207735.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-bfd1-75de-8bf0-9fca50207735",
        "storage_key": "property/6767906449166356/019d026d-bfd1-75de-8bf0-9fca50207735.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJbYoTlUcCyokREtg4-_gOqU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_17704d99-7414-4eb0-a91f-628f6598f4b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Meritus Medical Center",
      "poi_type": "Major Employers",
      "poi_address": "11116 Medical Campus Rd, Hagerstown, MD 21742, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-0254-76e5-8415-ca8503d398fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-0254-76e5-8415-ca8503d398fa",
        "storage_key": "property/6767906449166356/019fce12-0254-76e5-8415-ca8503d398fa.webp",
        "width": 962,
        "height": 1280
      },
      "poi_business_url": "http://www.meritushealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11059399238569098341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meritus-medical-center",
      "poi_latitude": "39.6228538",
      "poi_longitude": "-77.6848579",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 301-790-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-ba60-71de-9757-855e431981ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ba60-71de-9757-855e431981ab",
        "storage_key": "property/6767906449166356/019d026d-ba60-71de-9757-855e431981ab.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJn3H43DjtyYkRZfwiJAPhepk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6081e6d3-d05c-4bd3-9c66-25b64c9d88ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Western Maryland hospital",
      "poi_type": "Major Employers",
      "poi_address": "1500 Pennsylvania Ave, Hagerstown, MD 21742, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-20c9-77cc-b159-c7ed21ecbb0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-20c9-77cc-b159-c7ed21ecbb0a",
        "storage_key": "property/6767906449166356/019fce12-20c9-77cc-b159-c7ed21ecbb0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://health.maryland.gov/wmhc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11204667696972594158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-maryland-hospital",
      "poi_latitude": "39.6656455",
      "poi_longitude": "-77.71750639999999",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 301-745-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD9kjociSyYkR7ntY0Of5fps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e9f14a67-1122-4093-b11a-e1111f7cd22d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hagerstown VA Clinic",
      "poi_type": "Major Employers",
      "poi_address": "1101 Opal Ct Suite 202, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.martinsburg.va.gov/locations/hagerstown.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=8325006802359879840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagerstown-va-clinic",
      "poi_latitude": "39.6355218",
      "poi_longitude": "-77.6964874",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 304-263-0811 ext. 5130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-aeaa-709e-bb7a-98083a7669d5",
        "storage_key": "property/6767906449166356/019d026d-aeaa-709e-bb7a-98083a7669d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHw48Vd7syYkRoAhfN5RdiHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_58c85060-f18d-4500-b769-2d5be432c05e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Washington County Government",
      "poi_type": "Major Employers",
      "poi_address": "100 W Washington St, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.washco-md.net/PR-Marketing/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5584819922282462987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-county-government",
      "poi_latitude": "39.6434432",
      "poi_longitude": "-77.72276339999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 240-313-2380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-be9c-758a-bfe9-250f916f46c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-be9c-758a-bfe9-250f916f46c5",
        "storage_key": "property/6767906449166356/019d026d-be9c-758a-bfe9-250f916f46c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2z2RKALtyYkRC78rMiFEgU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ea1a2f2a-c7d4-454b-90e2-8551d4e2c4b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Washington County Circuit Court",
      "poi_type": "Major Employers",
      "poi_address": "24 Summit Ave, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-24ab-762b-9d1b-a9bee4666874.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-24ab-762b-9d1b-a9bee4666874",
        "storage_key": "property/6767906449166356/019fce12-24ab-762b-9d1b-a9bee4666874.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mdcourts.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12736351151285697394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-county-circuit-court",
      "poi_latitude": "39.6426167",
      "poi_longitude": "-77.722966",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 301-733-8660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-be9c-758a-bfe9-250f916f46c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-be9c-758a-bfe9-250f916f46c5",
        "storage_key": "property/6767906449166356/019d026d-be9c-758a-bfe9-250f916f46c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ304hZEftyYkRcnsFW-SbwLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8873292d-9c6a-47df-9fc6-4e9ecd61befb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hagerstown City Hall",
      "poi_type": "Major Employers",
      "poi_address": "1 E Franklin St, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-25ee-707d-94df-e0e403d979a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-25ee-707d-94df-e0e403d979a3",
        "storage_key": "property/6767906449166356/019fce12-25ee-707d-94df-e0e403d979a3.webp",
        "width": 1031,
        "height": 1280
      },
      "poi_business_url": "http://www.hagerstownmd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5755311005857294422&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagerstown-city-hall",
      "poi_latitude": "39.6430199",
      "poi_longitude": "-77.7190676",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 301-739-8577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-be9c-758a-bfe9-250f916f46c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-be9c-758a-bfe9-250f916f46c5",
        "storage_key": "property/6767906449166356/019d026d-be9c-758a-bfe9-250f916f46c5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3SYJqzntyYkRVigF7N343k8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_54c59ae1-0e33-4549-a333-cda14aba3001",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Washington County Public Schools - Center for Education Services",
      "poi_type": "Major Employers",
      "poi_address": "Downsville Pike, Hagerstown, MD 21740, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce12-286b-76cd-a448-67288e581aaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-286b-76cd-a448-67288e581aaa",
        "storage_key": "property/6767906449166356/019fce12-286b-76cd-a448-67288e581aaa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://wcpsmd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=634581604636960093&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-county-public-schools---center-for-education-services",
      "poi_latitude": "39.5979878",
      "poi_longitude": "-77.7645428",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 301-766-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b81c-709b-9a5d-e3a33005e0bf",
        "storage_key": "property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEcb05RTyyYkRXSVidZt8zgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a0cc04ba-5cdd-4d69-abb3-36779f87a0e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hagerstown Community College",
      "poi_type": "Major Employers",
      "poi_address": "11400 Robinwood Dr, Hagerstown, MD 21742, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-ef3d-737d-917e-f72948890c16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-ef3d-737d-917e-f72948890c16",
        "storage_key": "property/6767906449166356/019fce11-ef3d-737d-917e-f72948890c16.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.hagerstowncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245405847857137301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagerstown-community-college",
      "poi_latitude": "39.63183069999999",
      "poi_longitude": "-77.6691925",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 240-500-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b81c-709b-9a5d-e3a33005e0bf",
        "storage_key": "property/6767906449166356/019d026d-b81c-709b-9a5d-e3a33005e0bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ6ekwr3syYkRlQYwUtiPktM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2f9b25e3-9986-4ccc-a8d8-a57cadbe77d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Hagerstown Premium Outlets",
      "poi_type": "Major Employers",
      "poi_address": "495 Premium Outlets Blvd, Hagerstown, MD 21740, USA",
      "poi_short_description": "Village-feel outlet mall, eatery-equipped, outdoor-focused shopping venue featuring factory stores for name-brand apparel, accessories and home goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-db6e-770d-bd32-4fa094be8db9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-db6e-770d-bd32-4fa094be8db9",
        "storage_key": "property/6767906449166356/019fce11-db6e-770d-bd32-4fa094be8db9.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/hagerstown",
      "poi_directions_map_url": "https://maps.google.com/?cid=4191050910875414299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hagerstown-premium-outlets",
      "poi_latitude": "39.6080927",
      "poi_longitude": "-77.7331293",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 301-790-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b383-70b8-b52f-ebeccaef7c7d",
        "storage_key": "property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlQIjWoXtyYkRG29OKpmaKTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b9590cea-e2d4-44b3-9264-4b9799c67509",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "poi_name": "Valley Mall",
      "poi_type": "Major Employers",
      "poi_address": "17301 Valley Mall Rd, Hagerstown, MD 21740, USA",
      "poi_short_description": "Big mall offering department stores, diverse\nretailers, a theater with stadium seating & an arcade.",
      "poi_long_description": "Big mall offering department stores, diverse\nretailers, a theater with stadium seating & an arcade.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-dce4-7418-9e0a-009f2c187791.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce11-dce4-7418-9e0a-009f2c187791",
        "storage_key": "property/6767906449166356/019fce11-dce4-7418-9e0a-009f2c187791.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "https://shopthevalleymall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18411761373766768461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-mall",
      "poi_latitude": "39.6237752",
      "poi_longitude": "-77.77044719999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 301-582-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-b383-70b8-b52f-ebeccaef7c7d",
        "storage_key": "property/6767906449166356/019d026d-b383-70b8-b52f-ebeccaef7c7d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJARdv6fTyyYkRTVegdGu3g_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_2371e9f5-3e26-4b4b-af4a-f7aa55b1572c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_20f6dc96-39b0-47f4-a691-0acfe517f447",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_1d98a5d7-43a9-46d1-a7a6-ece924336aaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_81b49054-81c2-4363-98a3-807982d27e0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_dda25566-25c5-404c-83c0-92caa3378f65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_097ef151-d7e9-451f-a8a5-caec7fb7b17c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_6c3bac44-fe5e-4a1c-a52f-a96267181dbe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "rating": "5.0",
      "name": "Timothy Ackinclose",
      "text": "Over the summer months, Caleb, Paul, Brendy and David did maintenance work on my apartment.  I found them to be knowledgeable, punctual, and extremely courteous.  Not only did they address the various issues, but they also presented themselves with the highest degree of integrity.\n\nI am also writing in order to share my appreciation for The Ridge's Rental Office staff:  Carol, Martha, Yvette, and Brianna.  Even though they are very busy, they are willing to place maintenance orders for me as well as answer my questions.  I have consistently found them to be cheerful, polite, and knowledgeable.",
      "date": "2025-08-11",
      "title": ""
    },
    {
      "id": "custom_22651a30-0ea4-404b-87b6-f63487b27aa2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "rating": "5.0",
      "name": "Rebecca Fogle",
      "text": "The Ridge is a beautiful, clean neighborhood to live in. It’s quiet, the property is well maintained I couldn’t be happier. Carol was our leasing agent and she was very quick at getting us everything we needed to apply, to move in etc. she has an amazing and friendly personality. If you are looking for a new home come see her!",
      "date": "2025-07-30",
      "title": ""
    },
    {
      "id": "custom_afa7fc77-680a-40b5-a4ff-53ef78c47198",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "rating": "5.0",
      "name": "Cindi D",
      "text": "Had a seamless experience between touring, leasing, and moving in to my new apartment. Carol has been a huge part of the process and even helping me navigate being a new member of the community. She is beyond exceptional and loved working with her every step of the way.",
      "date": "2025-08-10",
      "title": ""
    },
    {
      "id": "custom_9e6d0bfc-dc60-4467-b081-316c587fee35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "rating": "5.0",
      "name": "Victoria O'Neil",
      "text": "My fiancé and I had toured a few apartments before deciding on this one. Carol was super friendly, helpful, and always got back to us in a timely manner. We have been here for 2 months now and we love this place! All the workers here seem to be on top of everything to make sure that everyone has a nice place to call home.",
      "date": "2025-08-26",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_442fbb30-9b10-45db-8dc7-f43443cc8892",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce70-e6c5-71f0-a3c1-ed6a7501ab7d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel sink, and black appliances.",
        "public_id": "019fce70-e6c5-71f0-a3c1-ed6a7501ab7d",
        "storage_key": "property/6767906449166356/019fce70-e6c5-71f0-a3c1-ed6a7501ab7d.webp",
        "width": 1920,
        "height": 1278
      },
      "virtual_tour_title": "360 Tours",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=633dd7fbd2ff397948155c4f"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_e2bcdbdc0831525e0137351f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "429332",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_789febd5a034afca38057241",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "429334",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 25,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_708cff836a57ebe036d4d254",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "429335",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_08a4704f575d1b6b6c00a91d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "429336",
      "name": "Pet Fee",
      "description": "One-time fee of $300 covers up to 2 pets.",
      "amount": 300,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6de90482e810534761f0aa1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "429339",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ce10acc5b398b4cdf8524445",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "429341",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_624fb34de883b7b2023eafe8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "429344",
      "name": "Reserved Parking Space",
      "description": "false",
      "amount": 25,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_5292ea8feb074975edbfe53a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "572051",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_49629eba678f3d55ff4fe299",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "572052",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_bf454f89726c7582a13e326c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "572054",
      "name": "Trash Service",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d41023e9a1d99086e279f59e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "572055",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_58a46ec1432b84d2e428fb81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "572057",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_eaf1c992be16785017cd0cb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "572059",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9d8d64d810088c44bfe5c51f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "832498",
      "name": "Late Fee",
      "description": "false",
      "amount": 5,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_5fc19e3f7fbea78a6ad972b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "832499",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_bd114233baa6145c1d4ae566",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "832500",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 25,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6f383b1f779236c6abc11e2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "832502",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_bd630b856d7e37d014b63498",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "832514",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_92391231e2f3089923c95327",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "engrain",
      "external_id": "835139",
      "name": "Admin Fee",
      "description": "Assessed per occurrence for any modification to the Lease Agreement, including but not limited to the addition, removal, or substitution of any leaseholder or occupant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a1714-2437-75ea-bb3c-81055df92469",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-the-ridge-apartments-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356"
    },
    {
      "lead_collector_id": "019c3043-b647-7336-83dc-9ff533112a86",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-ridge",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356"
    },
    {
      "lead_collector_id": "019c3043-b6ba-7709-a71e-92f6a7243893",
      "lead_source": "LANDING_PAGE",
      "name": "the-ridge",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-hagerstown-md-654",
      "search_query": "pet friendly apartments Hagerstown MD",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Hagerstown, MD",
      "h2_subtitle": "Discover the comfort of living in our pet friendly apartments in Hagerstown, MD. Enjoy amenities that cater to you and your furry companions.",
      "page_copy": "At The Ridge Apartments, we believe that your pets are family. Located in Hagerstown, MD, our pet-friendly community ensures a warm welcome to both you and your furry friends. We offer spacious one, two, and three-bedroom layouts perfect for pet owners, with an on-site Pet Play Area that guarantees fun and exercise for your beloved animals. Enjoy resort-style amenities, including a shimmering pool and a well-equipped fitness center, making leisure and relaxation just steps from your door.\n\nOur community is designed with every convenience in mind, offering scenic walking trails perfect for exploring with your pets. The Ridge Apartments not only provide all the comforts of a modern home but also embrace a pet-friendly lifestyle by offering on-site management dedicated to ensuring a harmonious community environment. Join us in Hagerstown, MD, for an unparalleled living experience catered to you and your furry companions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Hagerstown, MD",
      "seo_description": "Find pet friendly apartments in Hagerstown, MD at The Ridge Apartments. Enjoy modern amenities and a pet play area for your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "apartments-with-pool-washington-county-860",
      "search_query": "apartments with a pool in Washington County",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Washington County",
      "h2_subtitle": "Enjoy the luxury of apartments with a pool in Washington County. Experience resort-style amenities at The Ridge Apartments.",
      "page_copy": "Dive into the ultimate living experience at The Ridge Apartments, where our sparkling pool is the centerpiece of luxury living in Washington County. Our Hagerstown community boasts not only stylish one, two, and three-bedroom layouts but also resort-style amenities, including a sun-kissed sundeck complete with comfortable lounging options. Whether you're seeking a leisurely swim or a refreshing dip, our pool is the perfect place to unwind and socialize with neighbors.\n\nBeyond the pool, The Ridge Apartments offer a host of modern conveniences designed to elevate your lifestyle. Picture yourself enjoying a workout in our state-of-the-art fitness center, or taking a stroll along our scenic walking trails. With a range of amenities and a welcoming atmosphere, our residences are ideal for anyone seeking the perfect blend of relaxation and convenience in Washington County. Come see how life at The Ridge Apartments can transform your everyday routine.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Washington County",
      "seo_description": "Discover apartments with a pool in Washington County at The Ridge Apartments. Enjoy stylish living with luxurious amenities and a refreshing pool.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "dog-park-apartments-21740-200",
      "search_query": "dog park apartments 21740",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in 21740",
      "h2_subtitle": "Explore dog park apartments in the 21740 area. The Ridge Apartments offer an ideal living environment for pet owners in Hagerstown.",
      "page_copy": "Welcome to The Ridge Apartments, the perfect community for pet lovers searching for dog park apartments in the 21740 area. Nestled in Hagerstown, MD, our property features an exclusive Pet Play Area, providing a safe and fun environment for your furry friends to play and socialize. Our spacious one, two, and three-bedroom layouts are designed to accommodate the needs of pet owners, offering plenty of room for everyone in the family.\n\nOur community is not only pet-friendly but also brimming with amenities that enhance your lifestyle. Enjoy leisurely afternoons by the pool, keep fit in our state-of-the-art fitness center, or explore the scenic walking trails that surround our beautifully landscaped grounds. With on-site management dedicated to providing an exceptional living experience, The Ridge Apartments stand out as an ideal home for you and your pets in the 21740 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in 21740",
      "seo_description": "Find dog park apartments in 21740 at The Ridge Apartments. Enjoy a pet-friendly community with a dedicated Pet Play Area and stylish living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-hagerstown-431",
      "search_query": "fitness center apartments in Hagerstown",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Hagerstown",
      "h2_subtitle": "Discover fitness center apartments in Hagerstown at The Ridge. Live a health-focused lifestyle with modern amenities and facilities.",
      "page_copy": "Embrace a healthy lifestyle at The Ridge Apartments, where you'll find premier fitness center apartments in Hagerstown. Our community features a state-of-the-art fitness center equipped with modern gear, providing a convenient and inviting space for residents to stay active without having to leave home. Whether you prefer cardio, strength training, or a combination of both, our facilities cater to all your fitness needs.\n\nLocated in the scenic surroundings of Hagerstown, MD, The Ridge Apartments offer more than just a place to live. Enjoy a wealth of amenities including a shimmering pool, scenic walking trails, and spacious living accommodations in our one, two, and three-bedroom layouts. Join a community committed to promoting a balanced and vibrant lifestyle, where your well-being is always a top priority. Discover the perfect blend of comfort, convenience, and health-focused living at The Ridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Hagerstown",
      "seo_description": "Find fitness center apartments in Hagerstown at The Ridge. Enjoy a modern fitness facility and healthy living amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "apartments-with-ac-near-hagerstown-720",
      "search_query": "apartments with air conditioning near Hagerstown",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning Near Hagerstown",
      "h2_subtitle": "Find comfortable apartments with air conditioning near Hagerstown. The Ridge Apartments provide modern amenities and cool living spaces.",
      "page_copy": "Stay comfortable all year round at The Ridge Apartments, where you'll find apartments with air conditioning near Hagerstown designed for modern living. Our stylish one, two, and three-bedroom layouts come equipped with efficient air conditioning systems, ensuring that you and your family can enjoy a pleasant home environment regardless of the season.\n\nNestled in Hagerstown, MD, The Ridge Apartments are more than just a place to stay; they’re a lifestyle choice. Residents appreciate our wealth of amenities, including a refreshing pool, state-of-the-art fitness center, and expansive pet play area. With a focus on providing a convenient and relaxing living experience, our community sets itself apart as an ideal choice for those seeking a cool retreat from the hustle and bustle of everyday life. Experience the comfort and convenience of The Ridge Apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Air Conditioning Near Hagerstown",
      "seo_description": "Explore apartments with air conditioning near Hagerstown at The Ridge. Enjoy comfort and modern amenities in stylish, cool living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-hagerstown-md-405",
      "search_query": "one bedroom apartments Hagerstown MD",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Hagerstown, MD",
      "h2_subtitle": "Explore one bedroom apartments in Hagerstown, MD at The Ridge. Enjoy modern living in a vibrant community with resort-style amenities.",
      "page_copy": "Finding the perfect one bedroom apartment in Hagerstown, MD just got easier with The Ridge Apartments. Our thoughtfully designed layouts cater to your modern lifestyle, offering spacious and stylish living spaces. Each apartment is designed with comfort and convenience in mind, making it a perfect choice for singles or couples seeking a cozy home in a vibrant community.\n\nThe Ridge Apartments are situated in the heart of Hagerstown, providing residents with access to an array of exceptional amenities. Take advantage of our sparkling pool, state-of-the-art fitness center, and scenic walking trails. With a pet-friendly environment and attentive on-site management, The Ridge ensures a fulfilling and enjoyable living experience. Come home to comfort and community in our one bedroom apartments at The Ridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Hagerstown, MD",
      "seo_description": "Find one bedroom apartments in Hagerstown, MD at The Ridge. Enjoy modern amenities and stylish living in a vibrant, welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-near-21740-820",
      "search_query": "two bedroom apartments near 21740",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 21740",
      "h2_subtitle": "Discover spacious two bedroom apartments near 21740 at The Ridge. Enjoy modern amenities and a pet-friendly atmosphere.",
      "page_copy": "If you're searching for two bedroom apartments near the 21740 area, The Ridge Apartments in Hagerstown, MD are the perfect choice. Our spacious and thoughtfully designed two-bedroom layouts provide abundant living space, ideal for families, roommates, or those needing extra room for a home office. Each apartment is equipped with modern features that blend comfort and style.\n\nLocated conveniently near shopping, dining, and recreational options, The Ridge Apartments offer a vibrant community with a range of amenities. Relax by the sparkling pool, stay fit in the state-of-the-art fitness center, or take a stroll along our scenic walking trails. Our pet-friendly policy ensures all family members feel welcome. Experience a blend of luxury and convenience in our two bedroom apartments at The Ridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 21740",
      "seo_description": "Explore two bedroom apartments near 21740 at The Ridge. Enjoy spacious living and modern amenities in a convenient, pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-washington-county-4",
      "search_query": "three bedroom apartments Washington County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Washington County",
      "h2_subtitle": "Discover three bedroom apartments in Washington County at The Ridge. Enjoy large spaces and modern amenities designed for families.",
      "page_copy": "For families or those in need of extra space, the three bedroom apartments at The Ridge in Washington County offer an ideal solution. Nestled in Hagerstown, our layouts are designed with modern living in mind, providing ample room and contemporary finishes to suit your lifestyle needs. These spacious apartments ensure that each family member has their own cozy space, while also providing areas for gathering and entertainment.\n\nLocated in scenic Washington County, The Ridge Apartments provide residents with a host of impressive amenities. Enjoy leisure time by the refreshing pool, maintain an active lifestyle at our state-of-the-art fitness center, or invite furry friends to enjoy the pet play area. Our community ensures a comfortable and vibrant living experience, welcoming residents to explore the best of Hagerstown. Experience what our three bedroom apartments have to offer in style and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Washington County",
      "seo_description": "Find three bedroom apartments in Washington County at The Ridge. Spacious, modern homes with family-friendly amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "apartments-near-fountain-rock-elementary-hagerstown-50",
      "search_query": "apartments near fountain rock elementary hagerstown",
      "category": "School",
      "h1_title": "Apartments Near Fountain Rock Elementary",
      "h2_subtitle": "Find apartments near Fountain Rock Elementary in Hagerstown. The Ridge offers family-friendly living with modern amenities.",
      "page_copy": "Looking for apartments near Fountain Rock Elementary in Hagerstown? The Ridge Apartments provide the perfect blend of convenience and comfort for families. Our location offers easy access to a top-notch educational environment while ensuring a short commute. Our community features one, two, and three-bedroom layouts designed to accommodate families of all sizes, making The Ridge an ideal place to call home.\n\nAt The Ridge Apartments, residents enjoy amenities that enhance their lifestyle. Relax at the refreshing pool, keep fit at the well-equipped fitness center, or enjoy a stroll along our picturesque walking trails. Our pet-friendly community welcomes every family member, including furry friends, ensuring that everyone feels at home. Experience the convenience and quality of life offered by living near Fountain Rock Elementary at The Ridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Fountain Rock Elementary",
      "seo_description": "Discover family-friendly apartments near Fountain Rock Elementary in Hagerstown at The Ridge, offering modern amenities and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "the-ridge-apartments-near-springfield-middle-school-md-778",
      "search_query": "the ridge apartments close to springfield middle school md",
      "category": "School",
      "h1_title": "The Ridge Apartments Near Springfield Middle School",
      "h2_subtitle": "Explore The Ridge Apartments close to Springfield Middle School in MD, offering modern living and convenient access to education.",
      "page_copy": "Situated close to Springfield Middle School in MD, The Ridge Apartments offer the perfect balance of quality living and educational convenience. Our well-designed one, two, and three-bedroom layouts cater to diverse lifestyle needs, making them ideal for families looking to reside in a thriving community. With location being a top priority, The Ridge ensures a hassle-free commute to school, allowing more quality family time at home.\n\nResidents at The Ridge enjoy resort-like amenities that elevate daily living. You can unwind by our shimmering pool, work out in our modern fitness center, or enjoy peaceful moments walking the scenic trails. Our pet-friendly policy makes sure every member of the family feels welcome. Choosing The Ridge Apartments not only means selecting a comfortable home but also joining a supportive community in close proximity to Springfield Middle School, MD.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Ridge Apartments Near Springfield Middle School",
      "seo_description": "Live near Springfield Middle School, MD at The Ridge. Enjoy modern, family-friendly apartments with convenient access to education and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "rental-homes-near-williamsport-high-school-washington-county-438",
      "search_query": "rental homes near williamsport high school in washington county",
      "category": "School",
      "h1_title": "Rental Homes Near Williamsport High School",
      "h2_subtitle": "Discover rental homes near Williamsport High School in Washington County. Experience modern living at The Ridge Apartments, ideal for families and students.",
      "page_copy": "Families seeking rental homes near Williamsport High School in Washington County will find The Ridge Apartments to be a perfect match. Offering spacious one, two, and three-bedroom layouts, our community provides a modern and comfortable living environment. Situated conveniently, The Ridge ensures that students enjoy a short and easy commute to school, allowing more time to focus on studies and extra-curricular activities.\n\nAt The Ridge, we pride ourselves on providing top-notch amenities that cater to family needs and lifestyle desires. Residents can relax by the pool, stay healthy using the state-of-the-art fitness center, or simply unwind with a walk along our scenic trails. The pet-friendly atmosphere welcomes all family members, creating a harmonious living experience. Choose The Ridge Apartments as your rental home near Williamsport High School, where both comfort and convenience are paramount.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Near Williamsport High School",
      "seo_description": "Find rental homes near Williamsport High School in Washington County at The Ridge. Enjoy modern, family-friendly living with easy school access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "apartments-around-pangborn-elementary-hagerstown-39",
      "search_query": "apartments around pangborn elementary hagerstown",
      "category": "School",
      "h1_title": "Apartments Around Pangborn Elementary School",
      "h2_subtitle": "Looking for apartments around Pangborn Elementary in Hagerstown? Discover The Ridge Apartments, offering comfort and convenience for families.",
      "page_copy": "For those searching for apartments around Pangborn Elementary in Hagerstown, The Ridge Apartments offers a family-friendly community with modern amenities. Our spacious one, two, and three-bedroom floor plans cater to diverse family needs, making them an excellent choice for those who value proximity to quality education. The short commute to Pangborn Elementary allows families to maximize their time together and enrich their everyday living.\n\nThe Ridge's amenities provide a blend of relaxation and activity, perfect for today’s lifestyle. Unwind by the shimmering pool, take advantage of our fully equipped fitness center, or explore the beautiful walking trails with views that soothe the soul. Our pet-friendly policies ensure that every family member feels at home. Choose The Ridge Apartments and experience the advantage of living near Pangborn Elementary in Hagerstown.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Around Pangborn Elementary",
      "seo_description": "Find family-friendly apartments around Pangborn Elementary in Hagerstown at The Ridge, where comfort meets convenience with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "hagerstown-rentals-near-lincolnshire-elementary-176",
      "search_query": "hagerstown rentals near lincolnshire elementary",
      "category": "School",
      "h1_title": "Hagerstown Rentals Near Lincolnshire Elementary",
      "h2_subtitle": "Explore Hagerstown rentals near Lincolnshire Elementary. The Ridge Apartments offer a perfect blend of comfort, convenience, and family-friendly living.",
      "page_copy": "Looking for Hagerstown rentals near Lincolnshire Elementary? The Ridge Apartments provide an exceptional living experience in a convenient location perfect for families. With one, two, and three-bedroom layouts, the apartments boast modern designs tailored to a variety of lifestyles, making them an ideal choice for those with children attending nearby schools. Our proximity to Lincolnshire Elementary ensures a smooth and easy commute, giving families more opportunities to enjoy togetherness.\n\nBeyond location, The Ridge offers a range of amenities that enrich daily life. Residents benefit from a refreshing pool, a modern fitness center, and tranquil walking trails filled with scenic beauty. A pet-friendly environment ensures that all family members, including furry ones, feel welcome and cared for. Choose The Ridge Apartments for Hagerstown rentals that place you steps from Lincolnshire Elementary and center you within a thriving community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hagerstown Rentals Near Lincolnshire Elementary",
      "seo_description": "Discover Hagerstown rentals near Lincolnshire Elementary at The Ridge. Ideal for families seeking convenience and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "living-near-salem-avenue-elementary-school-21740-847",
      "search_query": "living near salem avenue elementary school 21740",
      "category": "School",
      "h1_title": "Living Near Salem Avenue Elementary School",
      "h2_subtitle": "Experience living near Salem Avenue Elementary School in 21740. The Ridge Apartments offer modern comfort in the heart of Hagerstown.",
      "page_copy": "Considering living near Salem Avenue Elementary School in the 21740 area? The Ridge Apartments offer a remarkable blend of comfort and convenience, making them the perfect choice for families seeking proximity to quality education. Our one, two, and three-bedroom apartments are designed with contemporary aesthetics and functionality in mind, creating a welcoming atmosphere for families. With such a close commute to Salem Avenue Elementary, children enjoy more relaxation and study time right at home.\n\nThe Ridge Apartments provide more than just a place to live. Our amenities are designed to elevate your lifestyle, featuring a resort-style pool, state-of-the-art fitness facilities, and picturesque walking trails ideal for refreshing walks. In our pet-friendly community, every family member feels valued and comfortable. Embrace the harmony of living near Salem Avenue Elementary School at The Ridge Apartments, and discover a community that truly feels like home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Salem Avenue Elementary School",
      "seo_description": "Enjoy living near Salem Avenue Elementary in 21740 at The Ridge, offering modern layouts and family-friendly amenities in Hagerstown.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "the-ridge-apts-location-near-st-mary-catholic-school-120",
      "search_query": "the ridge apts location near st mary catholic school hagerstown",
      "category": "School",
      "h1_title": "The Ridge Apts Near St. Mary Catholic School",
      "h2_subtitle": "Discover The Ridge Apts location near St. Mary Catholic School in Hagerstown, where family-friendly living meets modern convenience.",
      "page_copy": "For families seeking a home near St. Mary Catholic School in Hagerstown, The Ridge Apts offers an unbeatable location paired with modern amenities. Our one, two, and three-bedroom apartments are thoughtfully designed to accommodate the needs of growing families, ensuring comfort and style. Living so close to St. Mary Catholic School means that school mornings are stress-free, giving kids extra time and parents a little more peace of mind.\n\nThe Ridge Apartments provide an enriched living experience, featuring resort-style facilities such as a sparkling pool and a contemporary fitness center, perfect for unwinding after a busy day. Nature enthusiasts will appreciate the scenic walking trails, while pet owners can take joy in our pet-friendly environment. Choosing The Ridge Apts means enjoying both an ideal location near St. Mary Catholic School and a vibrant community lifestyle, making it a great place to call home in Hagerstown.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Ridge Apts Near St. Mary Catholic School",
      "seo_description": "Explore The Ridge Apts near St. Mary Catholic School in Hagerstown, offering family-friendly amenities and modern layouts for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "hagerstown-apartments-close-to-marshall-street-school-289",
      "search_query": "hagerstown apartments close to marshall street school",
      "category": "School",
      "h1_title": "Hagerstown Apartments Close to Marshall Street School",
      "h2_subtitle": "Discover Hagerstown apartments close to Marshall Street School, offering convenience and comfort at The Ridge Apartments in a thriving community.",
      "page_copy": "Are you searching for Hagerstown apartments close to Marshall Street School? The Ridge Apartments promise a welcoming environment just minutes away from this educational hub. Our stylish one, two, and three-bedroom layouts cater to various family sizes and lifestyles, ensuring a perfect fit for your living needs. Proximity to Marshall Street School means shorter commutes, allowing students more time at home and less time in transit.\n\nAlongside a prime location, residents of The Ridge benefit from top-notch amenities designed to elevate everyday life. Whether you're soaking up the sun by the pool, working out in our state-of-the-art fitness center, or strolling along our scenic walking trails, there's always something to enjoy. With a pet-friendly atmosphere, even your furry friends feel at home. Choose The Ridge Apartments for Hagerstown living that combines location convenience and community vibrancy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hagerstown Apartments Near Marshall Street School",
      "seo_description": "Find Hagerstown apartments close to Marshall Street School at The Ridge, offering modern living and family-friendly amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "the-ridge-close-to-hagerstown-community-college-md-320",
      "search_query": "the ridge close to hagerstown community college in md",
      "category": "School",
      "h1_title": "The Ridge Near Hagerstown Community College",
      "h2_subtitle": "Explore The Ridge close to Hagerstown Community College in MD, offering exceptional amenities and academic convenience.",
      "page_copy": "Looking for the ideal apartment close to Hagerstown Community College in MD? The Ridge Apartments provide a perfect blend of convenience and modern living just a short distance away. Our well-appointed one, two, and three-bedroom units are designed for students and professionals alike, ensuring you have a comfortable retreat after a long day on campus. This proximity allows students to enjoy reduced travel times, providing more opportunities for studying or relaxation.\n\nIn addition to our prime location, The Ridge offers amenities that support an active and balanced lifestyle. Whether you're cooling off in our sparkling pool, staying fit at the gym, or enjoying the tranquility of our walking trails, each feature is designed with resident satisfaction in mind. With our pet-friendly policy, you won't have to leave any family members behind. Experience the convenience of The Ridge Apartments, where college life meets community comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Ridge Close to Hagerstown Community College",
      "seo_description": "Live at The Ridge near Hagerstown Community College, MD. Enjoy proximity to campus, modern amenities, and a friendly community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "apartments-near-meritus-medical-center-hagerstown-251",
      "search_query": "apartments near Meritus Medical Center Hagerstown",
      "category": "Hospital",
      "h1_title": "Apartments Near Meritus Medical Center",
      "h2_subtitle": "Find modern apartments near Meritus Medical Center Hagerstown at The Ridge, offering a convenient lifestyle with premier amenities.",
      "page_copy": "For those seeking apartments near Meritus Medical Center in Hagerstown, The Ridge Apartments offers an unparalleled location with exceptional amenities. Our thoughtfully designed one, two, and three-bedroom floor plans provide the perfect setting for medical professionals and staff looking to reside close to work, reducing commute times and enhancing work-life balance. Living nearby means more time to focus on what matters most.\n\nResidents of The Ridge enjoy a plethora of amenities designed to support both relaxation and activity. Unwind by our resort-style pool, maintain your fitness in our modern gym, or take a leisurely stroll along our scenic walking trails. Additionally, we are a pet-friendly community, ensuring that all family members, including furry ones, are well accommodated. Choose The Ridge Apartments for a lifestyle that harmoniously combines location convenience and luxurious living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Meritus Medical Center Hagerstown",
      "seo_description": "Discover The Ridge Apartments near Meritus Medical Center, Hagerstown, offering modern living with convenient access and quality amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "apartments-near-fairgrounds-park-hagerstown-769",
      "search_query": "apartments near Fairgrounds Park Hagerstown",
      "category": "Park",
      "h1_title": "Apartments Near Fairgrounds Park Hagerstown",
      "h2_subtitle": "Discover apartments near Fairgrounds Park Hagerstown at The Ridge, offering comfort and connectivity in a scenic setting.",
      "page_copy": "Looking for apartments near Fairgrounds Park in Hagerstown? The Ridge Apartments offer a strategic location that combines the charm of park-side living with modern comfort. Our spacious one, two, and three-bedroom layouts cater to various lifestyles, perfect for those who enjoy outdoor activities and community events at nearby Fairgrounds Park, just a short walk away.\n\nThe Ridge Apartments provide an exceptional living experience with amenities that enhance your leisure and fitness routines. Dive into our refreshing pool, energize in our state-of-the-art fitness center, or simply relax on the sundeck after a day spent at the park. Welcoming pets into our community ensures every member of the family can feel at home. Experience the best of Hagerstown with the convenience of nature and recreational facilities at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Fairgrounds Park Hagerstown",
      "seo_description": "Live at The Ridge Apartments near Fairgrounds Park Hagerstown. Enjoy park-side living with modern amenities and a community-centric atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "the-ridge-apartments-by-pangborn-park-md-14",
      "search_query": "The Ridge Apartments by Pangborn Park MD",
      "category": "Park",
      "h1_title": "The Ridge Apartments by Pangborn Park",
      "h2_subtitle": "Experience The Ridge Apartments by Pangborn Park MD, where serene park views meet modern living.",
      "page_copy": "For those seeking a serene yet convenient living environment, The Ridge Apartments by Pangborn Park, MD, offer an ideal setting. With one, two, and three-bedroom layouts, these homes cater to a variety of needs, making them perfect for individuals and families alike. Living by Pangborn Park means access to beautiful green spaces and recreational activities, allowing residents to enjoy nature just beyond their doorstep.\n\nThe Ridge Apartments boast a host of amenities that complement the natural beauty surrounding them. Enjoy a relaxing day by the pool, work on fitness goals in our fully-equipped gym, or simply spend a sunny afternoon at our pet play area. This pet-friendly community ensures all family members, including the furry ones, feel welcome and at home. Choose The Ridge Apartments to embrace a lifestyle where nature and modern comfort coexist.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Ridge Apartments by Pangborn Park MD",
      "seo_description": "Discover The Ridge Apartments by Pangborn Park, MD, offering modern living with natural beauty and top-notch amenities close at hand.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "mills-park-adjacent-apartments-hagerstown-722",
      "search_query": "Mills Park adjacent apartments Hagerstown",
      "category": "Park",
      "h1_title": "Mills Park Adjacent Apartments in Hagerstown",
      "h2_subtitle": "Explore Mills Park adjacent apartments in Hagerstown at The Ridge, blending natural beauty with modern amenities.",
      "page_copy": "Looking for Mills Park adjacent apartments in Hagerstown? The Ridge Apartments offer a perfect combination of proximity to nature and contemporary living. Our one, two, and three-bedroom layouts are crafted to meet diverse lifestyle needs, providing a peaceful retreat just steps away from Mills Park. Residents enjoy easy access to recreational areas, promoting an active and vibrant lifestyle.\n\nThe Ridge Apartments elevate everyday living with resort-style amenities, including a sparkling pool, a modern fitness center, and a sun-drenched sundeck for relaxation. Additionally, our pet play area welcomes furry family members to our pet-friendly community. Experience the comfort and convenience of living next to Mills Park while enjoying the luxurious offerings at The Ridge Apartments in Hagerstown.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mills Park Adjacent Apartments Hagerstown",
      "seo_description": "Live at The Ridge Apartments near Mills Park, Hagerstown. Enjoy natural beauty and modern amenities in our welcoming, pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "kiwanis-park-accessible-apartments-washington-county-385",
      "search_query": "Kiwanis Park accessible apartments Washington County",
      "category": "Park",
      "h1_title": "Kiwanis Park Accessible Apartments",
      "h2_subtitle": "Discover Kiwanis Park accessible apartments in Washington County at The Ridge, offering excellent amenities and a prime location.",
      "page_copy": "Searching for Kiwanis Park accessible apartments in Washington County? The Ridge Apartments offer a perfect location combined with modern livability. Our community features well-designed one, two, and three-bedroom apartments, ideal for those who appreciate proximity to Kiwanis Park's recreational areas. Living here means enjoying the serene environment and active lifestyle options that the park provides, right in the heart of Washington County.\n\nThe Ridge Apartments stand out with a variety of resort-style amenities such as a refreshing swimming pool, a fully equipped fitness center, and scenic walking trails. Additionally, our pet-friendly policy ensures that all members of your family are comfortable. Embrace the perfect blend of nature and modern living at The Ridge, where Kiwanis Park is just a short stroll away, offering both relaxation and adventure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Kiwanis Park Accessible Apartments",
      "seo_description": "Live at The Ridge Apartments, accessible to Kiwanis Park in Washington County. Enjoy modern living with easy park access and superior amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "near-wheaton-park-hagerstown-apartments-488",
      "search_query": "near Wheaton Park Hagerstown apartments",
      "category": "Park",
      "h1_title": "Apartments Near Wheaton Park Hagerstown",
      "h2_subtitle": "Discover apartments near Wheaton Park in Hagerstown at The Ridge, offering modern amenities and parkside convenience.",
      "page_copy": "Looking for apartments near Wheaton Park in Hagerstown? The Ridge Apartments provides a welcoming community nestled close to this beautiful green space. Our selection of one, two, and three-bedroom apartments offer comfort and style, perfect for those seeking a harmonious blend of city convenience and natural serenity. Living just moments from Wheaton Park means you're never far from outdoor adventures and tranquil relaxation.\n\nLife at The Ridge Apartments is enhanced by a host of premium amenities. Unwind at our sparkling pool, stay active in our state-of-the-art fitness center, or enjoy a leisurely walk on our scenic trails. With our pet-friendly policy, even your furry companions can feel at home. Experience life near Wheaton Park, where modern living meets the natural charm of Hagerstown.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wheaton Park Hagerstown",
      "seo_description": "Find The Ridge Apartments near Wheaton Park, Hagerstown. Enjoy modern living with park access and excellent amenities in a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "living-by-hager-park-md-apartments-596",
      "search_query": "living by Hager Park MD apartments",
      "category": "Park",
      "h1_title": "Living by Hager Park MD Apartments",
      "h2_subtitle": "Discover living by Hager Park, MD with apartments at The Ridge, offering beautiful views and convenient amenities.",
      "page_copy": "Imagine living by Hager Park, MD, surrounded by the beauty of nature and the convenience of city life. The Ridge Apartments offer a fantastic opportunity for such a lifestyle. Our spacious one, two, and three-bedroom apartments are designed for modern living with easy access to Hager Park's recreational facilities, providing a perfect backdrop for relaxation and outdoor activities.\n\nAt The Ridge Apartments, residents enjoy a range of top-notch amenities, including a sparkling pool, modern fitness center, and walking trails that promote an active yet relaxed lifestyle. Our pet-friendly community welcomes all members of the family, ensuring that everyone can enjoy life near Hager Park. Experience the best of both worlds at The Ridge Apartments, where comfort meets the conveniences of living by Hager Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living by Hager Park MD Apartments",
      "seo_description": "Live at The Ridge near Hager Park, MD. Enjoy park views and modern lifestyle amenities in a welcoming, pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166356",
      "source": "custom",
      "page_item_url": "greenbrier-state-park-nearby-apartments-21740-137",
      "search_query": "Greenbrier State Park nearby apartments 21740",
      "category": "Park",
      "h1_title": "Apartments Near Greenbrier State Park",
      "h2_subtitle": "Explore nearby apartments in 21740, close to Greenbrier State Park, at The Ridge Apartments, where modern comfort meets nature.",
      "page_copy": "Searching for Greenbrier State Park nearby apartments in the 21740 area? Discover The Ridge Apartments, perfectly situated for those who love nature and modern living. Our community offers spacious one, two, and three-bedroom apartments that provide the comfort of home while placing you just a short drive from the stunning trails and scenic beauty of Greenbrier State Park.\n\nLiving at The Ridge Apartments means enjoying an array of on-site amenities like a relaxing pool, cutting-edge fitness center, and peaceful walking trails. Our pet-friendly policy ensures even your four-legged friends feel at home. With an ideal location near Greenbrier State Park, The Ridge Apartments offer the perfect balance of outdoor adventures and urban conveniences, all in the heart of the 21740 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and playground.",
        "public_id": "019fce11-8b84-710e-9cce-b0345bb18644",
        "storage_key": "property/6767906449166356/019fce11-8b84-710e-9cce-b0345bb18644.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Greenbrier State Park Nearby Apartments",
      "seo_description": "Find The Ridge Apartments near Greenbrier State Park, 21740. Enjoy modern living and convenient access to park adventures in a friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5093"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976290381"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973456"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5HZLRSPH"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://theridgehagerstown.fatwin.com/api/websites/resources/1?x=WmFDZWJEOUUyNTBJdHNwOFBKaytCallNbUpoMzdrR1k1QlVCc2xDV0F6RDNsQ3BmbVBLMTBhR3NYZmV3TEdPajlzTTVtRFRXNWFvdmJmSnJWbHUvTEE9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "14928381749"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rxwjq74zv1e"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9546f9dc-43e6-11ef-85d4-a7157eaea83b"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9546f9dc-43e6-11ef-85d4-a7157eaea83b/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9546f9dc-43e6-11ef-85d4-a7157eaea83b/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InNqYUkwdWdkQ3dGb3pUN091RFpqS3c9PSIsInZhbHVlIjoic3RkK3lOSTNtQWxWTTVTL2x1V3FIQT09IiwibWFjIjoiYjM5MGIzMjA2ZGVhZjQxM2I4NTI0Y2RmNTFlNTk3MDdiNTc0NGQ0OThhZDI0NGRiNWEzMWNhNGFjMGFkMmVlZCJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5093",
  "custom_repli_id": "9976290381",
  "custom_realpage_id": "4973456",
  "custom_google_gtm_id": "GTM-5HZLRSPH",
  "custom_perq_script_url": "https://theridgehagerstown.fatwin.com/api/websites/resources/1?x=WmFDZWJEOUUyNTBJdHNwOFBKaytCallNbUpoMzdrR1k1QlVCc2xDV0F6RDNsQ3BmbVBLMTBhR3NYZmV3TEdPajlzTTVtRFRXNWFvdmJmSnJWbHUvTEE9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "14928381749",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/rxwjq74zv1e",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9546f9dc-43e6-11ef-85d4-a7157eaea83b",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9546f9dc-43e6-11ef-85d4-a7157eaea83b/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9546f9dc-43e6-11ef-85d4-a7157eaea83b/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InNqYUkwdWdkQ3dGb3pUN091RFpqS3c9PSIsInZhbHVlIjoic3RkK3lOSTNtQWxWTTVTL2x1V3FIQT09IiwibWFjIjoiYjM5MGIzMjA2ZGVhZjQxM2I4NTI0Y2RmNTFlNTk3MDdiNTc0NGQ0OThhZDI0NGRiNWEzMWNhNGFjMGFkMmVlZCJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "5f64e7bf-4e53-462d-b26c-0d63091ab73b",
  "custom_audioeye_site_hash": "08e94c9fb2104c288bf28619fe5a9bce"
};

export const generatedAt = '2026-10-22T20:04:38.763Z';
